<template>
<div :class="modalMode ? 'details-in-modal mapping-modal' : 'pt-3 pl-5 pr-5'">
    <div class="mb-2" v-if="!modalMode">
      <breadCrumb :routesArray="routesArray"></breadCrumb>
    </div>
    <div class="flex flex-col flex-1 min-h-0 overflow-hidden">
      <div class="items-center justify-between flex h-6 flex-shrink-0">
        <div class="title flex items-center" v-if="!modalMode">
          <h1 :class="titleLength > 40? 'heading-ellipsis':''">{{presentControlObj.controlTitle}}</h1>
        </div>
        <div v-else></div>
        <div class="flex flex-row-reverse gap-3">
          <button
            class="flex"
            @click="filterOpen"
            v-if="selectedTabIndex==1"
            :class="
              (selectedTabIndex == 1 &&
                kpisListFromOrgPresentControl.length != 0) ||
              (selectedTabIndex == 2 && sortedData.length != 0)
                ? 'filterButton'
                : 'filterButtondisabled pointer-events-none'
            "
          >
            
            <img v-if="(selectedTabIndex == 1 && kpisListFromOrgPresentControl.length != 0) || (selectedTabIndex == 2 && sortedData.length != 0)" src="@/assets/filter.svg" class="filterIcon" />
            <img  v-else src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
            Filters
          </button>
          <button class="mr-3" v-if="selectedTabIndex == 1 && presentControlObj && presentControlObj.isActive==true" :class=" showTotalKpisWeightage < 100 &&!onSelectCheckBox ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="addKPI(kpi)">
            Add
          </button>
          <!-- <button class="mr-3 btnprimary" v-if="selectedTabIndex == 0" @click="editControlPopup()"> -->
            <!-- Edit
          </button> -->
          <!-- <button class="mr-3 btnprimary" v-if="selectedTabIndex==0 && presentControlObj" @click="editControlPopup()">
            Edit
          </button> -->
          <!-- <button class="mr-3 btnprimary" v-if="selectedTabIndex==1&&(presentControlObj && presentControlObj.isActive==true)&& displayEditButton" @click="editControlPopup()">
            Edit
          </button> -->
        </div>
      </div>
      <div class="mt-3 flex-shrink-0" v-if="!modalMode">
        <p class="headerText">
          {{ presentControlObj?.Description }}
        </p>
		  </div>
      <div class="mt-5 bg-white border border-lightgrey relative rounded mapping-tabs-shell flex flex-col min-h-0 flex-1">
        <div class="pt-5 px-5 pb-3 flex flex-col min-h-0 w-full flex-1">
    <Tabs  v-model:value="selectedTabIndex" scrollable>
      <div>
      <TabList>
            <Tab v-for="(tab,tabIndex) in carouselHead" :key="tabIndex" :value="tabIndex" @click="toggleTabs(tab.id)">
                {{ tab.displayName }}
            </Tab>
      </TabList>
      </div>
      <TabPanels>
        <TabPanel v-for="(tab,tabIndex) in carouselHead" :key="tabIndex" :value="tabIndex">
          <div v-if="dataLoading" class="flex items-center justify-center w-full h-64">
            <dots-loader />
          </div>
        <div v-else>
          <div v-if="selectedTabIndex==0" class="scrollBarColour tabStructure overflow-y-auto scrollbar-hidden">
              <!-- <div> -->
               <div v-if="tabDataLoading" class="flex items-center justify-center w-full h-64">
                  <dots-loader />
                </div>
                  <div v-else >
                    <div class="flex flex-row mt-3"> 
                               <!-- <div class="w-6/12">
                                  <label class="font-extrabold text-xs">Scope</label>
                                  <p class="text-sm mt-2" v-if="presentControlObj.controlFrequency!= undefined&& presentControlObj.controlFrequency!='' ">{{getControlFrequency(presentControlObj.controlFrequency)}}</p>
                                  <p class="text-sm mt-2" v-else>N/A</p>
                              </div>  -->
                              <div class="w-6/12">
                                  <label class="font-semibold controllabel">Tier</label>
                                  <p class="text-sm mt-2">{{presentControlObj.tier != undefined && presentControlObj.tier != '' ? presentControlObj.tier   : 'N/A'}}</p>
                              </div>
                              <div class="w-6/12">
                                  <label class="font-extrabold text-xs">Scope</label>
                                  <p class="text-sm mt-2">{{presentControlObj.tierTitle!= undefined&&presentControlObj.tierTitle!= '' ? presentControlObj.tierTitle: 'N/A'}}</p>
                              </div>  
                          </div>  
                          <div class="flex flex-row mt-3"> 
                              <div class="w-6/12">
                                  <label class="font-semibold controllabel">CID</label>
                                  <p class="text-sm mt-2">{{presentControlObj.clientUniqueId != undefined ? presentControlObj.clientUniqueId : 'N/A'}}</p>
                              </div>
                               <div class="w-6/12">
                                  <label class="font-extrabold text-xs">Frequency</label>
                                  <p class="text-sm mt-2" v-if="presentControlObj.controlFrequency!= undefined&& presentControlObj.controlFrequency!='' ">{{getControlFrequency(presentControlObj.controlFrequency)}}</p>
                                  <p class="text-sm mt-2" v-else>N/A</p>
                              </div> 
                              <!-- <div class="w-6/12">
                                  <label class="font-extrabold text-xs">Control Title</label>
                                  <p class="text-sm mt-2">{{presentControlObj.controlTitle!= undefined&&presentControlObj.controlTitle!= '' ? presentControlObj.controlTitle: 'N/A'}}</p>
                              </div>   -->  
                          </div>  
                          
                          <div class="flex flex-row mt-3"> 
                             <div class="w-6/12">
                                  <label class="font-extrabold text-xs">Priority</label>
                                  <div v-if="presentControlObj.controlPriority && typeof presentControlObj.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorLabelBg(presentControlObj.controlPriority)">
                                    <div class="text-xs" :class="colorLabelText(presentControlObj.controlPriority)">
                                      {{ getProirityLabel(presentControlObj.controlPriority) }}
                                    </div>
                                  </div>
                                  <div v-else class="text-sm mt-2">N/A</div>
                                  <!-- <p class="text-sm mt-2">{{presentControlObj.controlPriority != undefined ? presentControlObj.controlPriority : 'N/A'}}</p> -->
                              </div>
                               <div class="w-6/12">
                                  <label class="font-extrabold text-xs">Status</label>
                                  <div v-if="presentControlObj.isActive && presentControlObj.isActive==true"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorStatusBg(1)">
                                      <div class="text-xs" :class="colorStatusText(1)">
                                        {{ getStatusLabel(1) }}
                                      </div>
                                  </div>
                                  <div v-else-if="presentControlObj.isActive!=undefined && presentControlObj.isActive==false"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorStatusBg(2)">
                                    <div class="text-xs" :class="colorStatusText(2)">
                                      {{ getStatusLabel(2) }}
                                    </div>
                                  </div>
                                    <div v-else class="text-sm mt-2">N/A</div>
                                  </div>
                          </div> 
                          <div class="flex flex-row mt-3"> 
                                 <div class="w-6/12">
                                  <label class="font-extrabold text-xs">Class</label>
                                  <p class="text-sm mt-2">{{presentControlObj.controlClass != undefined&& presentControlObj.controlClass!='' ? presentControlObj.controlClass : 'N/A'}}</p>
                                </div>
                                <div class="w-6/12">
                                  <label class="font-extrabold text-xs">Family</label>
                                  <p class="text-sm mt-2">{{presentControlObj.controlFamily!= undefined && presentControlObj.controlFamily!= '' ? presentControlObj.controlFamily: 'N/A'}}</p>
                                </div>
                                <!-- {{ presentControlObj.owner }} -->
                                   
                             
                          </div>
                          <div class="flex flex-row mt-3">
                              <div class="w-6/12">
                                  <label class="font-extrabold text-xs">Owner</label>
                                  <p class="text-sm mt-2">{{ getOwnerName(presentControlObj.controlOwner) }}</p>
                              </div>
                          </div>
                          <div class="flex flex-row mt-3"> 
                                
                              <div class="w-6/12">
                                  <label class="font-extrabold text-xs">Category</label>
                                  <p class="text-sm mt-2">{{presentControlObj.controlType != undefined && presentControlObj.controlType != ''? presentControlObj.controlType : 'N/A'}}</p>
                              </div>
                          </div> 
                          <div class="w-full mt-3">
                              <label class="font-extrabold text-xs">Description</label>
                                  <p class="text-sm mt-2" v-if="(presentControlObj.Description!= undefined || presentControlObj.controlDescription!=undefined)&& (presentControlObj.Description!='' || presentControlObj.controlDescription!='') ">{{presentControlObj.Description?presentControlObj.Description:presentControlObj.controlDescription}}</p>
                                  <p class="text-sm mt-2" v-else>N/A</p>
                          </div>
                          <div class="flex flex-row mt-3"> 
                            <div class="w-full">
                                  <label class="font-extrabold text-xs">Policy/Procedure</label>
                                  <p class="text-sm mt-2">{{presentControlObj.controlPolicies != undefined && presentControlObj.controlPolicies != '' ? presentControlObj.controlPolicies : 'N/A'}}</p>
                              </div>
                          </div>
                          <div class="w-full mt-3">
                            <label class="font-extrabold text-xs">Guidance</label>
                            <p class="text-sm mt-2">{{presentControlObj.controlGuidance!= undefined &&  presentControlObj.controlGuidance!=''? presentControlObj.controlGuidance: 'N/A'}}</p>

                          </div>
                          <div class="flex flex-row mt-3"> 
                              <div class="w-full">
                                  <label class="font-extrabold text-xs">Task</label>
                                  <p class="text-sm mt-2">{{presentControlObj.controlMaintenanceTask!= undefined && presentControlObj.controlMaintenanceTask!= ''? presentControlObj.controlMaintenanceTask: 'N/A'}}</p>
                              </div>
                          </div>
                  </div>
              <!-- </div> -->
          </div>
          <div v-if="selectedTabIndex == 1" class="noScrollbar tabStructure1 mapping-tab-pane kpi-table-pane">
            <div v-if="tabDataLoading" class="flex items-center justify-center w-full h-64">
              <dots-loader />
            </div>
            <div v-else class="tableCornerRadius bg-white table-container kpi-table-scroll flex-1 min-h-0">
              <div class="table-container kpi-table-scroll">
              <table class="main-table">
                  <!-- {{ sortedAppliedKpisData }} -->
                <thead>
                  <tr class="buttomStyle table-header-row">
                    <th class="widthCheckBox">
                      <!-- <input type="checkbox" name="checkbox" v-model="selecteAllActiveKpis" class="checkbox cursor-pointer w-12" @change="deSelectKpis(1,$event)" :disabled="sortedAppliedKpisData.length==0 || disabledKpis.length ==0" v-if="editKpi==true"/> -->
                    </th>
                    <th
                      scope="col"
                      v-for="column in table1Heads"
                      :key="column"
                      :class="[column == 'status' ? '' : '',getColumnHeadWidth(column)]"
                      class="bg-white cursor-pointer capitalize"
                    >
                      <div @click="sort(column)">
                        <div class="flex" :class="[column == 'status' || column == 'target' ? 'justify-center' : '']">
                          <div v-if="column=='kpi_id'">KPI ID</div>
                          <div v-if="column == 'description'">KPI Name</div>
                          <div v-if="column == 'updatedon'">Updated On</div>
                          <div v-else-if="column == 'weightage'">
                            weightage (%)
                          </div>
                          <div v-else-if="column == 'target'">
                            Target
                          </div>
                          <div v-else-if="column == 'kpiType'">KPI Type</div>
                          <div v-else-if="column == 'status'">Status</div>
                          <div class="sort cursor-pointer" v-if="column != 'deleteIcon'" :class=" (className == column && selectedTabIndex == 1 && sortedAppliedKpisData.length != 0) || (selectedTabIndex == 2 && sortedData.length != 0) ? classSort : 'opacity-50'">
                          </div>
                        </div>
                      </div>
                      <div v-if="column == 'deleteIcon'"></div>
                    </th>
                  </tr>
                  <tr v-if="showFilters" class="table-filter-row">
                    <td></td>	
                    <td v-for="name in table1Heads" class="bg-white" :key="name">
                      <select
                        class="inputboxstyling resize"
                        v-if="
                          name == 'targetTimePeriod' ||
                          name == 'reportingFrequency'
                        "
                        v-model="filters[name]"
                      >
                        <option :value="filters.name" selected disabled hidden>
                          Select
                        </option>
                        <option
                          v-for="(value, index) in dbFrequency"
                          :key="index"
                          :value="value.value"
                        >
                          {{ value.key }}
                        </option>
                      </select>
                      <select class="inputboxstyling resize" v-if="name == 'kpiType'" v-model="filters[name]" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'">
                        <option :value="filters.name" selected disabled hidden>Select</option>
                        <option v-for="(value, index) in kpiTypeOptions" :key="index" :value="value.id">{{ value.name }}</option>
                      </select>
                      <select class="inputboxstyling resize" v-if="name == 'status'" v-model="filters[name]" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'">
                        <option :value="filters.name" selected disabled hidden>Select</option>
                        <option v-for="(value, index) in activeValues" :key="index" :value="value.id">{{ value.value }}</option>
                      </select>
                      <div v-else-if="name == 'deleteIcon' || name == 'weightage' ||name =='target'|| name=='kpiType' || name =='kpi_id'"></div>
                      <input
                        v-else
                        type="text"
                        class="searchForInputBoxStyling"
                        placeholder="Search"
                        v-model="filters[name]"
                      />
                    </td>
                    <td v-if="name == 'deleteIcon'"></td>
                  </tr>
                </thead>
                <!-- Table loading state -->
                <tbody v-if="tableLoading">
                  <tr class="cursor-pointer empty rowHeight">
                    <td class="relative h-5" :colspan="table1Heads.length + 1">
                      <div class="flex items-center justify-center w-full h-16">
                        <dots-loader/>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-else-if="columnObject || sortedAppliedKpisData.length === 0"
                >
                  <tr class="cursor-pointer rowHeight">
                    <td class="relative h-10" :colspan="table1Heads.length + 1">
                      <div class="flex justify-center">
                        <p class="text-xs font-normal">No Records Found</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else class="tbodylast">
                  <tr
                    v-for="(kpiData, index) in sortedAppliedKpisData"
                    :key="kpiData._id"
                    :class="index % 2 == 0 ? 'odd' : 'even'"
                    class="hoverEffectForCompleteRow"
                  >
                    <td class="checkBoxTd">
                      <div class="flex items-center" v-if='kpiData.isActive==true'>
                        <input
                          type="checkbox"
                          name="checkbox"
                          class="checkbox cursor-pointer"
                          :value="kpiData.referenceKpiId || kpiData._id"
                          v-model="checkedActiveKpis"
                          @change="changedActiveKpiInput(0, $event, kpiData.weightage)"
                        />
                      </div>
                      <div v-else>
                          <div class="checkbox bg-lightgrey flex items-center justify-center cursor-not-allowed">
                              <div class="border-disabledgrey horizontalCheckBox w-1/2"></div>
                          </div>
                      </div>
                    </td>
                    <td
                      v-for="column in table1Heads"
                      :key="column"
                      @mouseout="doFalse()"
                      class="cursor-pointer relative"
                      :class="column == 'target' || column == 'status' ? 'text-center' : ''"
                    >
                    <!-- {{ column }} -->
                      <div
                        v-if="
                          column == 'targetTimePeriod' ||
                          column == 'reportingFrequency'"
                      >
                        <div class="table-ellipsis">
                          <div class="inline">
                            {{
                              dbFrequency.find((itemOne) => {
                                return itemOne.value == kpiData[column];
                              })?.key||'N/A'
                            }}
                          </div>
                        </div>
                      </div>
                      <div v-else-if="column == 'deleteIcon'">
                        <div class="flex justify-center items-center h-7 w-7">
                          <div class="h-5 w-5"> <img src="@/assets/deleteIcon.svg" class="cursor-pointer h-5 w-5" @click="deleteKpiForControl(kpiData)"/>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="column == 'weightage'">
                        <div class="table-ellipsis pl-10">
                          <div class="inline">
                            {{ kpiData[column] }}
                          </div>
                        </div>
                      </div>
                      <div v-else-if="column == 'target'" class="text-center w-full">
                        {{ formatKpiTargetForDisplay(kpiData) }}
                      </div>
                      <div v-else-if="column == 'kpi_id'">
                        <div class="table-ellipsis">
                          <div class="inline">
                            {{ kpiData.kpi_id ? kpiData.kpi_id :'N/A'}}
                          </div>
                        </div>
                      </div>
                      <div v-else-if="column == 'kpiType'">
                        <div class="table-ellipsis">
                          <div class="inline">
                            <div v-if="kpiData.kpiType == 10603">Custom</div>
                            <div v-else-if="kpiData.kpiType == 10604">Built-in</div>
                            <div v-else-if="kpiData.kpiType == 2">Built-in</div>
                            <div v-else>N/A</div>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="column == 'updatedon'">
                        <div class="table-ellipsis">
                          <div class="inline">
                            <!-- {{ kpiData[column] }} -->
                            {{ formatTime(kpiData[column])}}
                          </div>
                        </div>
                      </div>
                      <div v-else-if="column=='status'">
                        <div class="rounded-full w-5 h-5 bg-active mx-auto" @mousemove="toolTip(column, $event, index, kpiData, 'circleButton')" v-if="kpiData[column] == true"></div>
                            <div class="rounded-full w-5 h-5 bg-error mx-auto" @mousemove="toolTip(column, $event, index, kpiData, 'circleButton')" v-else></div>
                            <div class="flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none" v-if="kpiData[column] == true && pop == true">
                              <img src="@/assets/tooltip.svg" alt="" class="absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3" />
                              <span class="text-black text-center text-xs"></span>
                              Active
                            </div>
                            <div class="flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none cursor-pointer" v-if="kpiData[column] == false && pop == true">
                              <img src="@/assets/tooltip.svg" alt="" class="absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3" />
                              <span class="text-black text-center text-xs"></span>
                              Inactive
                            </div>
                      </div>
                      <div v-else>
                        <div class="table-ellipsis">
                          <p class="inline fullText" @mousemove="toolTip(column, $event, index, kpiData, 'text')">
                            {{ kpiData[column] }}
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
              <div v-if="toolTipActive">
                <tool-tip :tipText="toolTipText"></tool-tip>
              </div>
              <div v-if="sortedAppliedKpisData.length != 0">
                <pagination
                  :dynamicPagination="dynamicPagination"
                  @currentPageUpdate="paginationUpdations"
                  :sortedData="sortedAppliedKpisData"
                ></pagination>
              </div>
            </div>
          </div>
          
          <!-- All KPIs Tab -->
          <div v-if="selectedTabIndex == 2" class="noScrollbar tabStructure history-tab-pane mapping-tab-pane">
            <!-- Tab-specific loading state -->
            <div v-if="tabDataLoading" class="flex items-center justify-center w-full h-64">
              <dots-loader />
            </div>
            <div v-else class="history-tab-inner flex flex-col flex-1 min-h-0 overflow-hidden pt-2">
                        <div class="border-b border-lightgrey flex justify-between pb-2 flex-shrink-0">
                            <div class="flex items-center justify-center">
                                <div>
                                <p class="header">History</p>
                                </div>
                            </div>
                            <div class="buttonposition flex justify-end items-center">
                                <button class="filterButton w-24 flex taskEditButtons" v-if="newHistory" @click="sortWorkLog()" :class="workLogObject?.[0] && Object.keys(workLogObject[0]).includes('history') && workLogObject[0].history?.length !== 0 ? 'btnprimary' : 'pointer-events-none'">
                                        <img src="@/assets/sortBy.svg" class="h-3 mr-2.5" />
                                        Oldest
                                </button>
                                <button class="filterButton w-24 flex taskEditButtons" v-if="!newHistory" @click="sortWorkLog()">
                                    <img src="@/assets/sortBy.svg" class="h-3 mr-2.5 rotate-180" />
                                    Newest
                                </button>
                            </div>
                        </div>
                        <div class="history-entries-scroll flex-1 min-h-0 overflow-y-auto pr-2">
                        <div v-for="work in workLogObject[0]?.history" :key="work" class="bg-white py-4 mb-0.5 border-lightgrey border-b">
                            <div class="flex">
                                <div v-if="Object.keys(work).includes('updatedBy')" class="initials">
                                    {{ extractInitials(work.name) }}
                                </div>
                                <div v-else-if="Object.keys(work).includes('createdBy')" class="initials">
                                    {{ extractInitials(work.name) }}
                                </div>
                                <div v-if="Object.keys(work).includes('activatedBy')" class="initials">
                                    {{ extractInitials(work.name) }}
                                </div>
                                <div class="logContainer w-93">
                                    <div class="flex">
                                      <p v-if="Object.keys(work).includes('activatedBy')" class="font-semibold mt-1.5 text-xs">
                                            {{work.name }}
                                      </p>
                                       <p v-if="Object.keys(work).includes('kpiStatus')" class="font-semibold mt-1.5 text-xs">
                                            {{work.name }}
                                      </p>
                                      <!-- <div  v-if="work.activatedBy && work.controlStatus==true && !work.hasOwnProperty('currentPriority') && !work.hasOwnProperty('currentFrequency')" class="mx-2 mt-1.5 text-xs"> -->
                                      <p  class="mx-2 mt-1.5 text-xs" v-if="Object.keys(work).includes('actionType') && work.actionType==10301 && Object.keys(work).includes('controlStatus') && work.controlStatus==true &&!Object.keys(work).includes('previousPriority')&& !Object.keys(work).includes('previousFrequency')">{{ 'Activated the ' }}<b>{{`${work.clientUniqueId}`}} </b> {{ 'on' }}<span class="pl-2"><b>{{formatHistoryTime(work.activatedAt)}}</b></span></p>
                                                        <!-- </div> -->
                                      <!-- <p  class="mt-1.5 text-xs" v-if="Object.keys(work).includes('actionType') && work.actionType==10303 && Object.keys(work).includes('controlStatus') && work.controlStatus==false">{{ 'Inactivated the ' }}<b>{{`${work.clientUniqueId}`}} </b> {{ 'on' }}<span class="pl-2">{{formatTime(work.activatedAt)}}</span></p> -->
                                      <div v-if="Object.keys(work).includes('actionType') && work.actionType==10303 && Object.keys(work).includes('controlStatus') && work.controlStatus==false" class="mx-2 mt-1.5 text-xs">
                                        <p>{{ 'Deactivated the ' }}<b>{{`${work.clientUniqueId}`}} </b><span class="ml-2">{{ 'on' }}</span><span class="pl-2"><b>{{formatHistoryTime(work.activatedAt)}}</b></span> </p>
                                      </div>
                                      <p  class="mx-2 mt-1.5 text-xs" v-if="Object.keys(work).includes('actionType') && work.actionType==10302 && Object.keys(work).includes('controlStatus') && work.controlStatus==true && (!work.previousPriority&& !work.previousFrequency)">{{ 'Activated the ' }}<b>{{`${work.clientUniqueId}`}} </b> {{ 'on' }}<span class="pl-2"><b>{{formatHistoryTime(work.activatedAt)}}</b></span></p>
                                      <p v-if="Object.keys(work).includes('kpiStatus') && work.kpiStatus==true" class="mx-2 mt-1.5 text-xs"> Activated the kpi: <b>{{`${work.kpiTitle}`}}</b> on <b>{{formatHistoryTime(work.updatedAt)}}</b></p>
                                      <!-- <p v-else-if="Object.keys(work).includes('kpiStatus') && work.kpiStatus==false" class="mx-2 mt-1.5 text-xs"> Inactivated the kpi: <b>{{`${work.kpiTitle}`}}</b> at <b>{{formatHistoryTime(work.updatedAt)}}</b></p> -->
                                      <div v-else-if="Object.keys(work).includes('kpiStatus') && work.kpiStatus == false">
                                          <p class="mx-2 mt-1.5 text-xs">
                                            Inactivated the kpi: <b>{{ work.kpiTitle }}</b> at <b>{{ formatHistoryTime(work.updatedAt) }}</b>
                                          </p>
                                      </div>
                                      <p v-else-if="Object.keys(work).includes('actionType') && work.actionType==10301 &&Object.keys(work).includes('controlStatus') && work.controlStatus==false " class="mt-1.5 text-xs"> Inactivated the <b>{{`${work.clientUniqueId}`}}</b> at <b>{{formatHistoryTime(work.updatedAt)}}</b></p>
                                       <div  v-else-if="Object.keys(work).includes('previousPriority')" class="mx-2 mt-1.5 text-xs">
                                            <!-- {{'from'}} -->
                                              <p>
                                                  {{ 'Updated the ' }}
                                                  <b>{{ work.clientUniqueId }}</b>
                                                  <span class="ml-2">{{ 'on' }}</span>
                                                  <span class="pl-2"><b>{{ formatHistoryTime(work.activatedAt) }}</b></span>
                                              </p>
                                              <div class="mt-3">
                                                  <span :class="colorLabelBg(work.previousPriority)" class="inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding" v-if="work.previousPriority&&typeof work.previousPriority!='string'">
                                                    <span :class="colorLabelText(work.previousPriority)" class="text-xs">
                                                        {{ getProirityLabel(work.previousPriority) }}
                                                    </span>
                                                </span>
                                                <span  v-else>
                                                    N/A
                                                </span>
                                                {{ ' to ' }}
                                                    <span :class="colorLabelBg(work.currentPriority)" class="inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding">
                                                    <span :class="colorLabelText(work.currentPriority)" class="text-xs">
                                                        {{ getProirityLabel(work.currentPriority) }}
                                                    </span>
                                                </span>
                                              </div>                                           
                                            </div>  
                                            <div  v-else-if="work.activatedBy && work.previousPriority && work.controlStatus==false" class="mx-2 mt-1.5 text-xs">
                                              <p>
                                              {{ 'Updated the ' }}
                                              <b>{{ work.clientUniqueId }}</b>
                                              <span class="ml-2">{{'on'}}</span>
                                                  <span class="pl-2"><b>{{ formatHistoryTime(work.updatedAt) }}</b></span>
                                              </p>
                                            <div class="mt-3">
                                                <span :class="colorLabelBg(work.previousPriority)" class="inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding" v-if="work.previousPriority&&typeof work.previousPriority!='string'">
                                                  <span :class="colorLabelText(work.previousPriority)" class="text-xs">
                                                      {{ getProirityLabel(work.previousPriority) }}
                                                  </span>
                                              </span>
                                              <span  v-else>
                                                  N/A
                                              </span>
                                              {{ ' to ' }}
                                                  <span :class="colorLabelBg(work.currentPriority)" class="inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding">
                                                  <span :class="colorLabelText(work.currentPriority)" class="text-xs">
                                                      {{ getProirityLabel(work.currentPriority) }}
                                                  </span>
                                              </span>
                                              <b>in InactiveControls</b>
                                            </div>                                           
                                    </div>  
                                    <div  v-else-if="(work.updatedBy|| work.activatedBy)&&work.previousFrequency" class="mx-2 mt-1.5 text-xs">
                                      <p>
                                          {{ 'Updated the ' }}
                                          <b>{{ work.clientUniqueId }}</b>
                                          <span class="ml-2">{{ 'on' }}</span>
                                          <span class="pl-2"><b>{{ formatHistoryTime(work.updatedAt || work.activatedAt) }}</b></span>
                                      </p>
                                      <div class="mt-3">
                                          {{ 'from' }}
                                          <span>
                                          <b>{{ getFrequencyValue(work.previousFrequency)}}</b>
                                          </span>
                                          {{ ' to ' }}
                                          <span>
                                          <b>{{ getFrequencyValue(work.currentFrequency) }}</b>
                                          </span>
                                      </div>
                                      </div> 
                                </div>
                                    <div
                                      v-if="(Object.keys(work).includes('actionType') && work.actionType==10303 && Object.keys(work).includes('controlStatus') && work.controlStatus==false) || (Object.keys(work).includes('kpiStatus') && work.kpiStatus == false)"
                                      class="mt-1 text-xs"
                                    >
                                      <b>Justification:</b><span class="ml-0.5">{{ work.justification || 'N/A' }}</span>
                                    </div>
                            </div>
                        </div>
                        </div>
                        </div>
              <div v-if="toolTipActive">
                <tool-tip :tipText="toolTipText"></tool-tip>
              </div>
            </div>
          </div>
      </div>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </div>
        <div v-if="selectedTabIndex == 1" class="card-footer-actions bottom-7 bg-white h-14 flex justify-between w-full rounded-b-sm flex-shrink-0" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
          <div class="flex items-center text-sm ml-5" v-if="!tabDataLoading">
            Total Weightage is: {{ showTotalKpisWeightage }} %
          </div>
          <div class="flex items-center px-5 mx-5"  v-if="!tabDataLoading">
            <button class="mr-2" :class="arraysAreEqual ? 'btndisabled pointer-events-none' : 'btnprimary'" @click="cancelActiveKpis()">Cancel</button>
            <button :class="arraysAreEqual? 'btndisabled pointer-events-none' : 'btnprimary'" :disabled="clickOnButton" @click="saveKpisForControl(checkedActiveKpis,'manual')">Save</button>
          </div>
        </div>
          <!-- <div v-if="selectedTabIndex == 2" class="bottom-7 bg-white h-14 flex justify-between w-full rounded-b-sm" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
            <div class="flex items-center text-sm ml-5">
              Total Weightage is: {{ showTotalKpisWeightage }} %
            </div>
            <div class="flex items-center px-5 mx-5">
            <button class="mr-2" :class="selectedRootKpis.length > 0 ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="cancelRelatedKpis()">Reset</button>
            <button @click="saveKpisForPresentOrgControl(selectedRootKpis, 'direct')" :disabled="clickOnButton" :class="selectedRootKpis.length > 0 && !(showTotalKpisWeightage > 100)? 'btnprimary' : 'btndisabled pointer-events-none'">Save</button>
            </div>
          </div> -->
       
      </div>
      <popup v-if="showPopup" :popUp="showPopup">
        <template v-slot:header>
          <div class="flex items-center justify-between py-4 px-2 rounded">
            <h1 class="pl-2">Manage KPI</h1>
            <button
              class="float-right text-3xl"
              @click="
                onCancelbtn();
                showPopup = false;
              "
            >
              <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
            </button>
          </div>
        </template>
        <div class="flex flex-col h-full">
        <div class="flex-1 overflow-auto">
        <fieldset>
          <div>
            <div>
              <div class="statuscontainer popupbodycontainer">
                <div class="formcontainer flex flex-col">
                  <div class="row flex flex-row w-full upperspacing">
                    <div class="w-full">
                      <label class="controllabel">KPI Name</label>
                      <textarea
                        type="text"
                        class="inputboxstyling h-20 max-h-48 mt-2"
                        v-model.trim="addingKpiObj.description"
                        @input="v$.addingKpiObj.description.$touch()"
                        placeholder="KPI Name"
                        :class="{
                          'is-invalid': v$.addingKpiObj.description.$error || isDuplicateData.description,
                        }"
                      ></textarea>
                      <div v-if="v$.addingKpiObj.description.$error" class="text-red-500">
                        <div class="error-text" v-if="v$.addingKpiObj.description.required.$invalid">Required</div>
                        <div v-else-if="v$.addingKpiObj.description.restrictCharacters100.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                      </div>
                      <div v-if="isDuplicateData.description" class="text-red-500">
                        <div class="error-text text-xs">KPI Name already exists.</div>
                      </div>
                    </div>
                  </div>
                  <div class="row flex flex-row w-full mt-3 gap-3">
                    <div class="w-6/12">
                      <label class="controllabel">Kpi Id</label>
                      <input
                          type="text"
                          class="inputboxstyling mt-2 disiableState kpi-form-field"
                          v-model.trim="addingKpiObj.kpi_id"
                          placeholder="Number"
                          disabled
                      />
                    </div>
                    <div class="w-6/12">
                      <label class="controllabel">Target Type</label>
                      <Select
                        v-model="addingKpiObj.targetType"
                        :options="targetTypeOptions"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Please select the option"
                        class="w-full custom-multiselect userSelect mt-2 kpi-operator-select"
                        :class="{ 'is-invalid': v$.addingKpiObj.targetType.$error }"
                        @change="targetGreaterThanZero(addingKpiObj.target)"
                      />
                      <div v-if="v$.addingKpiObj.targetType.$error" class="text-red-500">
                        <div class="error-text" v-if="v$.addingKpiObj.targetType.required.$invalid">Required</div>
                      </div>
                    </div>
                  </div>
                  <div class="row flex flex-row w-full mt-3 gap-3">
                    <div class="w-6/12">
                      <label class="controllabel">Condition</label>
                      <Select
                        v-model="addingKpiObj.kpiCondition"
                        :options="kpiConditionOptions"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Please select the option"
                        class="w-full custom-multiselect userSelect mt-2 kpi-operator-select"
                        :class="{ 'is-invalid': v$.addingKpiObj.kpiCondition.$error }"
                      />
                      <div v-if="v$.addingKpiObj.kpiCondition.$error" class="text-red-500">
                        <div class="error-text" v-if="v$.addingKpiObj.kpiCondition.required.$invalid">Required</div>
                      </div>
                    </div>
                    <div class="w-6/12">
                      <label class="controllabel">{{ addingKpiObj.targetType === 'number' ? 'Target' : 'Target(%)' }}</label>
                      <input
                          type="number"
                        class="inputboxstyling mt-2 kpi-form-field"
                        v-model.trim="addingKpiObj.target"
                        :maxlength="addingKpiObj.targetType === 'number' ? 10 : 3"
                        ref="editTarget"
                        :placeholder="addingKpiObj.targetType === 'number' ? 'Target' : 'Target (%)'"
                        @keyup="targetLessThanZero(addingKpiObj.target); targetGreaterThanZero(addingKpiObj.target); handleTargetInput"
                        :class="{
                          'is-invalid': v$.addingKpiObj.target.$error || validTargetError || targetNumberLessThanZero,
                        }"
                      />
                      <div
                        v-if="v$.addingKpiObj.target.$error || validTargetError || targetNumberLessThanZero"
                        class="text-red-500"
                      >
                        <div
                          class="error-text"
                          v-if="v$.addingKpiObj.target.required.$invalid"
                        >
                          {{ addingKpiObj.targetType === 'number' ? 'Target is required' : 'Target (%) is required' }}
                        </div>
                        <div
                          class="error-text"
                          v-if="(validTargetError && !v$.addingKpiObj.target.required.$invalid) || (targetNumberLessThanZero == true && !v$.addingKpiObj.target.required.$invalid)"
                        >
                          {{ addingKpiObj.targetType === 'number' ? 'Target is Invalid' : 'Target(%) is Invalid' }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row flex flex-row w-full mt-3 gap-3">
                    <div class="w-6/12">
                      <label class="controllabel">Weightage (%)</label>
                      <input
                        type="number"
                        class="inputboxstyling mt-2 kpi-form-field"
                        v-model.trim="addingKpiObj.weightage"
                        maxlength="3"
                        ref="editWeight"
                        placeholder="Weightage (%)"
                        @keyup="weightageLessThanZero(addingKpiObj.weightage) || weightageGreaterThanZero(addingKpiObj) && handleInput"
                        :class="{
                          'is-invalid': v$.addingKpiObj.weightage.$error || validtaionWeightageError || numberLessThanZero,
                        }"
                      />
                      <div
                        v-if="v$.addingKpiObj.weightage.$error || validtaionWeightageError || numberLessThanZero"
                        class="text-red-500"
                      >
                        <div
                          class="error-text"
                          v-if="v$.addingKpiObj.weightage.required.$invalid"
                        >
                          Weightage (%) is required
                        </div>
                        <div
                          class="error-text"
                          v-if="(validtaionWeightageError && !v$.addingKpiObj.weightage.required.$invalid) || (numberLessThanZero == true && !v$.addingKpiObj.weightage.required.$invalid)"
                        >
                          Weightage(%) is Invalid
                        </div>
                      </div>
                    </div>
                    <div class="w-6/12"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        </div>
        <div>
          <div class="border-b border-solid border-lightgrey mx-5"></div>
            <div
              v-if="buttonVisible==false"
              class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5"
            >
              <button
                class="mr-1.5"
                :class="
                  disableStatus
                    ? 'btnprimary'
                    : 'btndisabled pointer-events-none'
                "
                @click="onCancelbtn()"
              >
                Cancel
              </button>
              <button
                :class="
                  disableStatus
                    ? 'btnprimary'
                    : 'btndisabled pointer-events-none'
                "
                @click="addOrUpdateKpiForControlManual(addingKpiObj)"
              >
                Update
              </button>
            </div>
            <div
              v-else
              class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5"
            >
              <button
                class="mr-1.5"
                :class="
                  disableStatus
                    ? 'btndisabled pointer-events-none'
                    : 'btnprimary'
                "
                @click="onCancelbtn()"
              >
                Reset
              </button>
              <button
                :class="
                  disableStatus
                    ? 'btndisabled pointer-events-none'
                    : 'btnprimary'
                "
                @click="addOrUpdateKpiForControlManual(addingKpiObj)"
              >
                Save
              </button>
            </div>
        </div>
        </div>
      </popup>
        <popup v-if="controlEditPopup" :popUp ="controlEditPopup">
        <template v-slot:header>
            <div class="flex items-center justify-between py-4 pl-2 pr-4 rounded">
                <h1  class="pl-2">{{presentControlObj?.controlTitle||'N/A'}}</h1>
                <!-- <div v-else class="pl-2">
                    <h1 v-if="addpopup==false" >{{customControlObject.controlTitle || 'N/A'}}</h1>
                    <h1 v-else>Control</h1>
                </div> -->
                <button class="float-right text-3xl" @click="onCancelbtnCustom('close')">
                    <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                </button>
            </div>
        </template>
<!-- <div> -->
    <div class="flex flex-col h-full">
        <div class="flex-1 overflow-auto">
            <fieldset>
                <div>
                    <div class="statuscontainer popupbodycontainer">
                        <div class="formcontainer flex flex-col">
                            <div v-if="addControlpopup==true" class="row flex flex-row w-full ">
                                <div class="w-full mt-3">
                                    <label class="controllabel">Title</label>
                                    <!-- <div class="mb-3 mt-2 text-sm">{{ customControlObject.controlTitle || 'N/A'}}</div> -->
                                    <textarea 
                                        type="text-area"
                                        class="inputboxstyling mt-2"
                                        placeholder="Title"
                                        @input="v$.presentControlObj.controlTitle.$touch()" 
                                        v-model.trim="presentControlObj.controlTitle"
                                        :class="{
                                            'is-invalid': v$.presentControlObj.controlTitle.$error
                                        }"
                                    ></textarea>
                                    <div v-if="v$.presentControlObj.controlTitle.$error" class="text-red-500">
                                        <div class="error-text" v-if="v$.presentControlObj.controlTitle.required.$invalid">Required</div>
                                        <div v-else-if="v$.presentControlObj.controlTitle && v$.presentControlObj.controlTitle.restrictCharacters100.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                             <div class="formcontainer flex flex-col">
                              <div class="row flex flex-row w-full mt-3">
                                <div class="w-6/12" :class="{'topspace': addControlpopup}">
                                        <label class="controllabel">Number</label>
                                        <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ presentControlObj?.clientUniqueId || 'N/A'}}</div>
                                        <input
                                            v-else
                                            type="text"
                                            class="inputboxstyling mt-2"
                                            v-model.trim="presentControlObj.controlNumber"
                                            @input="v$.presentControlObj.controlNumber.$touch()"
                                            placeholder="Number"
                                            disabled
                                        />
                                    </div>
                              <div class="w-6/12 pl-4" :class="{'topspace': addControlpopup}">
                                <div class="flex flex-col">
                                  <label class="controllabel mr-2 mb-2">Status</label>
                                  <ToggleSwitch v-model="controlsEditData.isActive" :checked="controlsEditData.isActive"	/>
                                </div>
                              </div>
                              
                              </div>
                            </div>
                            <div class="formcontainer flex flex-col">
                                <div class="row flex flex-row w-full">
                                    <div class="w-3/6" :class="{'topspace': addControlpopup}">
                                        <label class="controllabel">Frequency</label>
                                        <!-- <div v-if="addControlpopup==true" class="text-sm mt-2 mb-3">{{ controlFrequencyArray.find(item => item.id === presentControlObj.controlFrequency)?.label ?? 'N/A' }}</div> -->
                                        <!-- <div> -->
                                            <Select 
                                                v-model="controlsEditData.controlFrequency"
                                                :options="dbFrequency"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                class="w-full custom-multiselect userSelect mt-2"
                                                 :class="{
                                                  'is-invalid': v$.controlsEditData.controlFrequency.$error
                                                  }"
                                            />
                                            <div v-if="v$.controlsEditData.controlFrequency.$error" class="text-red-500">
                                             <div class="error-text" v-if="v$.controlsEditData.controlFrequency.required.$invalid">Required</div>
                                            </div> 
                                            
                                        <!-- </div> -->
                                
                                    </div>
                                    
                                    <div class="w-6/12 pl-4" :class="{'topspace': addControlpopup}">
                                        <label class="controllabel">Priority</label>
                                        <!-- <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">

                                        {{ dbPriority.find(item => item.value === presentControlObj.controlPriority)?.key || 'N/A' }}
                                        </div> -->
                                        <!-- <div>
                                            
                                        </div> -->
                                        <!-- <select  class="mt-2" v-model="controlsEditData.controlPriority" :class="{'is-invalid': v$.controlsEditData.controlPriority.$error,'inputboxstylingForSelectAtPopup': controlsEditData.controlPriority === '','stylingForInputboxstylingForSelectAtPopup': controlsEditData.controlPriority !== ''}">
                                            <option value="" selected disabled hidden>Select</option>
                                            <option class="optionColors" v-for="(value, index) in dbPriority" :key="index" :value="value.value">{{ value?.key }}</option>
                                        </select> -->
                                        <Select 
                                            v-model="controlsEditData.controlPriority"
                                            :options="dbPriority"
                                            optionLabel="key"
                                            optionValue="value"
                                            placeholder="Please select one"
                                            class="w-full custom-multiselect userSelect mt-2"
                                             :class="{
                                            'is-invalid': v$.controlsEditData.controlPriority.$error
                                            }"
                                           
                                        />
                                        <div v-if="v$.controlsEditData.controlPriority.$error" class="text-red-500">
                                            <div class="error-text" v-if="v$.controlsEditData.controlPriority.required.$invalid">Required</div>
                                        </div> 
                                    </div>
                                
                                </div>
                            </div>
                            <div class="formcontainer flex flex-col">
                              <div class="row flex flex-row w-full">
                                  <div class="w-6/12  mt-3" :class="{'topspace': addControlpopup}">
                                      <label class="controllabel">Tier</label>
                                      <div class="mb-3 mt-2 text-sm">{{ presentControlObj.tier|| 'N/A'}}</div> 
                                  </div>
                                  <div class="w-6/12 pl-4 mt-3" :class="{'topspace': addControlpopup}">
                                      <label class="controllabel">Scope</label>
                                      <div class="mb-3 mt-2  text-sm">{{ presentControlObj.tierTitle|| 'N/A'}}</div> 
                                  </div>
                              </div>
                            </div>

                            <div class="formcontainer flex flex-col">
                                <div class="row flex flex-row w-full">
                                    <div class="w-6/12" :class="{'topspace': addControlpopup}">
                                        <label class="controllabel">Family</label>
                                        <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ presentControlObj.controlFamily || 'N/A'}}</div>
                                        <multiselect
                                            v-else
                                            v-model="presentControlObj.controlFamily"
                                            :options="filteredControlFamilyOptions"
                                            :showNoOptions="false"
                                            @search-change="asyncFindControlFamily"
                                            :multiple="false"
                                            :searchable="true"
                                            open-direction="bottom"
                                            :hideArrow="false"
                                            placeholder="Family"
                                            class="custom-multiselect userSelect mt-2"
                                        >
                                            <template v-slot:noResult>
                                                <span class="text-xs">No Families Found</span>
                                            </template>
                                        </multiselect>
                                    </div>

                                    <div class="w-3/6 pl-4" :class="{'topspace': addControlpopup}">
                                        <label class="controllabel">Class</label>
                                        <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ presentControlObj.controlClass || 'N/A'}}</div>
                                        <input
                                            v-else
                                            type="text"
                                            class="inputboxstyling mt-2"
                                            @input="v$.presentControlObj.controlClass.$touch()"
                                            placeholder="Class"
                                           
                                            v-model.trim="presentControlObj.controlClass"
                                        />
                                        <!-- <div v-if="v$.presentControlObj.controlClass.$error" class="text-red-500">
                                            <div v-if="v$.presentControlObj.controlClass && v$.presentControlObj.controlClass.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="formcontainer flex flex-col ">
                                <div>
                                    <div :class="{'topspace': addControlpopup}">
                                        <div>
                                        <label class="controllabel">Category</label>
                                        <div class="mt-2"> 
                                            <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ presentControlObj?.controlType || 'N/A'}}</div>
                                            <input
                                                v-else
                                                type="text"
                                                class="inputboxstyling"
                                                @input="v$.presentControlObj.controlType.$touch()"
                                                v-model.trim="presentControlObj.controlType"
                                                placeholder="Type"
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            </div>
                            <div class="w-full mb-3">
                              <label class="font-extrabold text-xs">Description</label>
                                  <div v-if="addControlpopup==false" class="mt-2 text-sm">{{ presentControlObj.Description || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling mt-2"
                                        @input="v$.presentControlObj.Description.$touch()"
                                        placeholder="Description"
                                        v-model.trim="presentControlObj.Description"
                                       
                                    >
                                    </textarea>
                                    
                          </div>

                            <!-- <div class="row flex flex-row w-full" :class="{'topspace': addControlpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Audit Methodology</label>
                                    <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ presentControlObj.controlAuditMethodology || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling mt-2"
                                        @input="v$.presentControlObj.controlAuditMethodology.$touch()"
                                        placeholder="Audit Methodology"
                                        v-model.trim="presentControlObj.controlAuditMethodology"
                                       
                                    >
                                    </textarea>
                                    
                                </div>
                            </div> -->

                            <!-- <div class="row flex flex-row w-full" :class="{'topspace': addControlpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Audit Success Criteria</label>
                                    <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ presentControlObj.controlAuditSuccessCriteria || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Audit Success Criteria"
                                        v-model.trim="presentControlObj.controlAuditSuccessCriteria"
                                        @input="v$.presentControlObj.controlAuditSuccessCriteria.$touch()"
                                        
                                    >
                                    </textarea>
                                    
                                </div>
                            </div> -->

                            <!-- <div class="row flex flex-row w-full" :class="{'topspace': addControlpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Maintenance Task</label>
                                    <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ presentControlObj.controlMaintenanceTask || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Maintenance Task"
                                        v-model.trim="presentControlObj.controlMaintenanceTask"
                                        @input="v$.presentControlObj.controlMaintenanceTask.$touch()"
                                        :class="{
                                            'is-invalid': v$.presentControlObj.controlMaintenanceTask.$error
                                        }"
                                    
                                    >
                                    </textarea>
                                   
                                </div>
                            </div> -->

                            <div class="row flex flex-row w-full" :class="{'topspace': addControlpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Policies</label>
                                    <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ presentControlObj.controlPolicies || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Policies"
                                        v-model.trim="presentControlObj.controlPolicies"
                                        @input="v$.presentControlObj.controlPolicies.$touch()"
                                        :class="{
                                            'is-invalid': v$.presentControlObj.controlPolicies.$error
                                        }"
                                    
                                    >
                                    </textarea>
                                    
                                </div>
                            </div>

                            <div class="row flex flex-row w-full " :class="{'topspace': addControlpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Guidance</label>
                                    <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ presentControlObj.controlGuidance || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Guidance"
                                        v-model.trim="presentControlObj.controlGuidance"
                                        @input="v$.presentControlObj.controlGuidance.$touch()"
                                        :class="{
                                            'is-invalid': v$.presentControlObj.controlGuidance.$error
                                        }"
                                    
                                    >
                                    </textarea>
                                    
                                </div>
                            </div>

                            <div class="w-full col-md-6 " :class="{'topspace': addControlpopup}">
                                <label class="controllabel">Frameworks</label>
                                <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ presentControlObj.controlOptionFrameWork || 'N/A'}}</div>
                                <multiselect
                                    v-else
                                    v-model="presentControlObj.controlOptionFrameWork"
                                    @select="getFrameworkControls(presentControlObj.controlOptionFrameWork)"
                                    :multiple="false"
                                    :options="frameWorksList"
                                    :searchable="true"
                                    open-direction="bottom"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :show-labels="false"
                                    placeholder="Frameworks"
                                    class="custom-multiselect mt-2"
                                >
                                    <template v-slot:noResult>
                                        <span class="text-xs">No Frameworks Found</span>
                                    </template>
                                </multiselect>
                            </div>

                            <div class="w-full col-md-6 " :class="{'topspace': addControlpopup}">
                                <label class="controllabel">Controls</label>
                                <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ presentControlObj.frameworkControls || 'N/A'}}</div>
                                <multiselect
                                    v-else
                                    v-model="presentControlObj.frameworkControls"
                                    :multiple="false"
                                    :options="frameworkControls"
                                    :searchable="true"
                                    open-direction="bottom"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    placeholder="Controls"
                                    class="custom-multiselect mt-2"
                                    
                                >
                                    <template v-slot:noResult>
                                        <span class="text-xs">No Controls Found</span>
                                    </template>
                                </multiselect>
                            </div>

                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
        <div>
            <div class="border-b border-solid border-lightgrey mx-5"></div>
                <div v-if="presentControlObj._id" class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
                <button class="btnprimary mr-1.5" :class="JSON.stringify(controlsEditData)!==JSON.stringify(dummyControlObj) ? 'btnprimary' : 'btndisabled pointer-events-none'"  @click="onCancelbtnCustom('activecancel')">Reset</button>
                <button class="btnprimary" :class="JSON.stringify(controlsEditData)!==JSON.stringify(dummyControlObj) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="editCustomControl(controlsEditData,'edit')">Save</button>          
            </div>
        </div>
</div>
    </popup>
         <popup v-if="deActivatingPopup" :popUp ="deActivatingPopup">
        <template v-slot:header>
            <div class="flex items-center justify-between py-4 pl-2 pr-4 rounded">
                <h1  class="pl-2">{{presentControlObj?.controlTitle||'N/A'}}</h1>
                <!-- <div v-else class="pl-2">
                    <h1 v-if="addpopup==false" >{{customControlObject.controlTitle || 'N/A'}}</h1>
                    <h1 v-else>Control</h1>
                </div> -->
                <button class="float-right text-3xl" @click="onCancelbtnCustom('deactivateclose')">
                    <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                </button>
            </div>
        </template>
<!-- <div> -->
        <div class="flex flex-col h-full">
        <div class="flex-1 overflow-auto">
            <fieldset>
                <div>
                    <div class="statuscontainer popupbodycontainer">
                        <div class="formcontainer flex flex-col">
                            <div class="row flex flex-row w-full upperspacing">
                                <div class="w-full">
                                    <label class="controllabel">Reason/Justification for Deactivating the control</label>
                                    <textarea
                                    type="text-area"
                                    class="inputboxstyling mt-2"
                                    placeholder="Reason/Justification for Deactivating the control"
                                    v-model="deActiveControlObject.justification"
                                    :class="{
                                        'is-invalid': v$.deActiveControlObject.justification.$error
                                        }"                                    
                                    > </textarea>
                                    <div v-if="v$.deActiveControlObject.justification.$error" class="text-red-500">
                                    <div class="error-text text-xs" v-if="v$.deActiveControlObject.justification.required.$invalid">Required</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
<div>
    <div class="border-b border-solid border-lightgrey mx-5"></div>
        <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
        <button
            class="btnprimary mr-1.5"
            :class="isObjectEmpty(deActiveControlObject) ? 'btnprimary' : 'btndisabled pointer-events-none'"
            @click="onCancelbtnCustom('deactivecancel')"
        >
            Reset
        </button>
        <button class="btnprimary" 
            :class="isObjectEmpty(deActiveControlObject) ? 'btnprimary' : 'btndisabled pointer-events-none'"
        @click="editCustomControl(deActiveControlObject,'deActive')"
        >
        Save
        </button>          
        </div>

        </div>
    </div>
<!-- </div> -->
        </popup>
        <popup v-if="deActivatingKPIPopup" :popUp ="deActivatingKPIPopup">
        <template v-slot:header>
            <div class="flex items-center justify-between py-4 pl-2 pr-4 rounded">
                <h1  class="pl-2">{{ deactivatingKpiName }}</h1>
                <!-- <div v-else class="pl-2">
                    <h1 v-if="addpopup==false" >{{customControlObject.controlTitle || 'N/A'}}</h1>
                    <h1 v-else>Control</h1>
                </div> -->
                <button class="float-right text-3xl" @click="onCancelbtnCustom('deactivateclose')">
                    <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                </button>
            </div>
        </template>
<!-- <div> -->
        <div class="flex flex-col h-full">
        <div class="flex-1 overflow-auto">
            <fieldset>
                <div>
                    <div class="statuscontainer popupbodycontainer">
                        <div class="formcontainer flex flex-col">
                            <div class="row flex flex-row w-full upperspacing">
                                <div class="w-full">
                                    <label class="controllabel">Reason/Justification for Deactivating the KPI</label>
                                    <textarea
                                    type="text-area"
                                    class="inputboxstyling mt-2"
                                    placeholder="Reason/Justification for Deactivating the KPI"
                                    v-model.trim="deActiveKPIObject.justification"
                                    :class="{
                                        'is-invalid': v$.deActiveKPIObject.justification.$error
                                        }"                                    
                                    > </textarea>
                                    <div v-if="v$.deActiveKPIObject.justification.$error" class="text-red-500">
                                    <div class="error-text text-xs" v-if="v$.deActiveKPIObject.justification.required.$invalid">Required</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
<div>
    <div class="border-b border-solid border-lightgrey mx-5"></div>
        <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
        <button
            class="btnprimary mr-1.5"
            :class="isObjectEmpty(deActiveKPIObject) ? 'btnprimary' : 'btndisabled pointer-events-none'"
            @click="onCancelbtnCustom('deactivecancel')"
        >
            Reset
        </button>
        <button class="btnprimary" 
            :class="isObjectEmpty(deActiveKPIObject) ? 'btnprimary' : 'btndisabled pointer-events-none'"
            @click="confirmDeactivateKpis"
        >
        Save
        </button>          
        </div>
        </div>
    </div>
<!-- </div> -->
    </popup>
    <MessageDialog
        v-model:visible="showMessageDialog"
        :activeControls="[]"
        :mode="messageDialogMode"
        :tasks="inProgressTasks"
        loadingMessage="Inactivating Control please wait a moment"
        @cancel="onMessageDialogCancel"
        @ok="onMessageDialogOk"
        @ok-tasks="onMessageDialogOkTasks"
    />
    </div>
  </div>
</template>
<style scoped>
.horizontalCheckBox{
    border-width: 1.5px;
}
.main-table{
  min-width: 1000px;
}
.table-container {
  overflow-y: auto;
  min-height: 0;
}
.kpi-table-pane {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.kpi-table-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  max-height: 100%;
}
.history-tab-pane {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.history-tab-inner {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.history-entries-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.main-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #ffffff;
}
.widthCheckBox{
width:1%;
}
.widthFivePercent{
  width: 7%;
}
.zIndex{
	z-index: 1;
}
:deep(.p-tabpanels){
  padding-bottom:0px !important;

}
.Vue-Toastification__container {
  z-index: 999999999 !important;
}
.checkBoxTh:first-child,
.checkBoxTd:first-child {
  width: 75px;
}
.table-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.heading-ellipsis {
  width: 50%;
  display:-webkit-box !important;
  -webkit-line-clamp: 1 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.anime-left {
  animation-name: moveLeft;
  animation-duration: 1s;
  animation-iteration-count: 1;
  animation-fill-mode: backwards;
}
@keyframes moveLeft {
  0% {
    opacity: 1;
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(0);
  }
}
.anime-right {
  animation-name: moveRight;
  animation-duration: 1s;
  animation-iteration-count: 1;
  animation-fill-mode: backwards;
}
.scrollbar-hidden {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.scrollbar-hidden::-webkit-scrollbar {
  display: none;
}
@keyframes moveRight {
  0% {
    opacity: 1;
    transform: translateX(-100vw);
  }
  100% {
    transform: translateX(0);
  }
}
.fullText{
    white-space: break-spaces;
    font-size: 12px;
}
.progressbarSI {
  border: 2px solid #e9e9e9;
  border-radius: 16px;
  margin-right: 4px;
  background: #e9e9e9;
  position: relative;
  top: -8px;
}
.progress {
  border-radius:16px;
  background: #1976d2 !important;
}
.tbodylast:last-child {
  border-bottom: 1px solid #e9e9e9;
}
.primary{
  color:#1976d2;
}
::-webkit-scrollbar {
	width: 3px !important;
}
.noScrollbar::-webkit-scrollbar {
  display: none;
}
.scrollBarColour::-webkit-scrollbar,
.scrollBarColour::-webkit-scrollbar-thumb,
.scrollBarColour::-webkit-scrollbar-track { 
	width: 4px;
	border: none;
	background: transparent;
}
/* Hides additional scrollbar elements like buttons and corners */
.scrollBarColour::-webkit-scrollbar-button,
.scrollBarColour::-webkit-scrollbar-track-piece,
.scrollBarColour::-webkit-scrollbar-corner,
.scrollBarColour::-webkit-resizer {
	display: none;
}
/* Custom thumb style */
.scrollBarColour::-webkit-scrollbar-thumb {
	border-radius: 6px;
	background-color: var(--color-primary); /* Thumb color */
}

/* Custom track with image background */
.scrollBarColour::-webkit-scrollbar-track {
	background-image: url("../../assets/scrollLine.svg");
	background-repeat: repeat-y;
	background-size: contain;
	filter: grayscale(100%) sepia(100%) hue-rotate(180deg) saturate(200%) brightness(80%);
  }


.scrollBarColour::-webkit-scrollbar-track {
	border-radius: 6px;
	width: 1px;
}
.scrollBarColour::-webkit-scrollbar-thumb {
	background: var(--color-primary);
	border-radius: 6px; 
	width: 2px;
}
.scrollBarColour::-webkit-scrollbar {
    height: 8px; 
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.tabStructure1 {
  height: calc(100vh - 308px);
}
.tabStructure {
  height: calc(100vh - 253px);
}

/* Firefox */
/* input[type=number] {
  -moz-appearance: textfield;
} */
 .total-weightage {
  margin-top: auto; }

input:checked {
  background-color: white;
  border: 2px solid #1976d2
}
.kpi-form-field {
  height: 31px;
  box-sizing: border-box;
}
:deep(.kpi-operator-select.p-select) {
  height: 31px;
  min-height: 31px;
  box-sizing: border-box;
  align-items: center;
  border-radius: 0.125rem;
}
:deep(.kpi-operator-select.p-select:not(.is-invalid)) {
  border-color: #e9e9e9 !important;
}
:deep(.kpi-operator-select.p-select.is-invalid) {
  border: 1px solid red !important;
}
:deep(.kpi-operator-select .p-select-label) {
  height: 31px !important;
  line-height: 23px !important;
  display: flex;
  align-items: center;
  padding: 4px 10px !important;
  font-size: 0.875rem !important;
  font-weight: 400 !important;
}
:deep(.kpi-operator-select .p-select-dropdown) {
  width: 2rem;
}
</style>

<script lang="ts">
import { required, requiredIf } from "@vuelidate/validators";
import { helpers } from "@vuelidate/validators";
const { withParams } = helpers;
const numeric = helpers.regex("numeric", /^[0-9]+$/i);
const lessthanHundred = helpers.regex("lessthan", /^[1-9][0-9]?$|^100$/i);
const validateMetricsArray = withParams({ type: "array" }, (value: any) => {
  return Array.isArray(value) && value.length > 0;
});
const customValidator = withParams({ type: "array" }, validateMetricsArray);

import _ from "lodash";
import dotsLoader from '@/components/dotsLoader.vue'
import { defineComponent } from "vue";
import useVuelidate from "@vuelidate/core";
import { emitter, toast } from "@/main";
import tableData from "@/components/tableData.vue";
import breadCrumb from "@/components/breadCrumb.vue";
import popup from "@/components/popup.vue";
import pagination from "@/components/pagination.vue";
import toolTip from "@/components/toolTip.vue";
import Multiselect from 'vue-multiselect';
import { v4 as uuidv4 } from "uuid";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
const restrictCharacters100 = helpers.regex(/^[\s\S]{0,100}$/);
import Select from 'primevue/select'
import { mapGetters } from "vuex";
import moment from "moment";
import ToggleSwitch from 'primevue/toggleswitch';
import MessageDialog from '@/components/messageDialog.vue';

export default defineComponent({
  props: {
    controlId: { type: [String, Number], default: null },
    type: { type: [String, Number], default: null },
    modalMode: { type: Boolean, default: false },
  },
  emits: ['header-info', 'open-nested'],
  data(): any {
    return {
      v$: useVuelidate(),
      kpiIds:[],
      showFilters: false,
      dummyList: [],
      hideFormula: false,
      addingKpiObj: {
        kpi_id: "",
        weightage: "",
        description: "",
        target: "",
        kpiCondition: null,
        targetType: null,
      },
      kpiConditionOptions: [
        { label: "'≥' Greater than or Equal to", value: "gte" },
        { label: "'≤' Less than or Equal to", value: "lte" },
        { label: "'>' Greater than", value: "gt" },
        { label: "'<' Less than", value: "lt" },
        { label: "'=' Equal to", value: "eq" },
      ],
      targetTypeOptions: [
        { label: "Percentage", value: "percentage" },
        { label: "Number", value: "number" },
      ],
      deActiveKPIObject:{
        justification:'',
      },
      customKpiId:[],
      dummyObj: [],
      systems:[],
      allProjects:[],
      activitiesList:[],
      showPopup: false,
      dataLoading: true,
      tabDataLoading: false,
      tableLoading: false,  // New variable for table loading state
      showBlockindex: '',
      dimmykpisListFromOrgPresentControl:[],
      showBlock: false,
      columnObject: false,
      actionBtn: false,
      showDropDown: false,
      selectedRowIndex: null,
      controlRecurringArray: [
        { label: "Daily", id: 1 },
        { label: "Weekly", id: 2 },
        { label: "Monthly", id: 3 },
        { label: "Quarterly", id: 4 },
        { label: "Half-Yearly", id: 5 },
        { label: "Yearly", id: 6 },
      ],
      ObjectIncludedTier:[
        {
          id:10107,
          value:'Activity'
        },
        {
          id:10108,
          value:'System'
        },
        {
          id:10109,
          value:'Project'
        }
      ],
      activeValues: [
				{
					id: 1,
					value: 'Active'
				},
				{
					id: 2,
					value: 'Inactive'
				}
			],
      controlFrequencyArray: [
				{ label: 'Daily', id: 1 },
				{ label: 'Weekly', id: 2 },
				{ label: 'Monthly', id: 3 },
				{ label: 'Quarterly', id: 4 },
				{ label: 'Semi Annualy', id: 5 },
				{ label: 'Annualy', id: 6 },
				{ label: 'Transactional', id: 7 },
			],
      tableDataActionOptions: [
        {
            id: 1,
            value: 'Delete'
        },
      ],
      routesArray: [],
      allOrgControls: [],
      allRootControls: [],
      presentControlObject: {},
      allRootKpis: [],
      kpisListFromOrgPresentControl: [],
      addedKpiNamesList: [],
      addedKpiNamesListExcludindSelectedKpi: [],
      allRootKpisUnfiltered: [],
      tipText: '',
      tipColumn: '',
      tipIndex: '',
      toolTipActive : false,
      toolTipText : '',
      carouselHead: [
        { displayName: "Details" , name:"ControlInformation",id : 0},
        { displayName: "KPIs", name: "Kpis", id: 1 },
        { displayName: "History", name: "History", id: 2 },
      ],
      selectedTabIndex: null,
      validtaionWeightageError: false,
      validTargetError:false,
      sideButton: false,
      titleLength: 0,
      styling: { left: "", bottom: "" },
      allKpisList: [],
      pageSize: 20,
      currentPage: 1,
      dynamicPagination: "",
      currentSort: "name",
      currentSortDir: "asc",
      classSort: "",
      className: "",
      filters: {},
      selectedRootKpis: [],
      pop: false,
      showTotalKpisWeightage: 0,
      table1Heads: ["kpi_id","description","updatedon","kpiType", "weightage","target","status"],
      table2Heads: ["description","kpiType", "weightage","target"],
      tableRow:[],
      allRootKpisData:[],
      numberLessThanZero : false,
      targetNumberLessThanZero:false,
      inputValue: '',
      clickOnButton:false,
      buttonVisible:false,
      checkedActiveKpis:[],
      defaultCheckedActiveKpis:[],
      selecteAllActiveKpis:false,
      kpiTypeOptions:[
        {
          id:10604,
          name: 'Built-in'
        },
        {
          id:10603,
          name: 'Custom'
        }
      ],
      clientCustomKpi:false,
      selecteAllRelatedKpis: false,
      onSelectCheckBox:false,
      allControlsList:[],
      presentControlObj:{},
      controlEditPopup:false,
      controlsEditData:{},
      addControlpopup:false,
      dummyControlObj:{},
      editKpi:false,
      optionsUserArray:[],
      users:[],
      disabledKpis:[],
      workLogObject:[],
      newHistory: true,
      deActivatingPopup:false,
      deActiveControlObject:{
        justification:'',
        forceUpdate:''
      },
      deActivatingKPIPopup:false,
      pendingFinalArr:[],
      showMessageDialog: false,
      dialogTitle: '',
      dialogMessage: '',
      inProgressTasks: [] as any[],
      pendingDeactivateRequest: null as null | { scopeId: any; inactiveType: number; payload: any },
      messageDialogMode: 'confirm' as 'confirm' | 'loading' | 'success' | 'tasks',
    };
  },
  components: {
    Multiselect,
    pagination,
    popup,
    breadCrumb,
    toolTip,
    dotsLoader,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    Select,
    ToggleSwitch,
    MessageDialog
    },
  validations() {
    return{
      addingKpiObj: {
        weightage: { required },
        target:{required},
        description: { required, restrictCharacters100 },
        kpiCondition: { required },
        targetType: { required },
      },
      deActiveKPIObject:{
        justification:{required}
      },
      controlsEditData:{
            controlPriority:{ required },
            controlFrequency:{ required }
        },
      deActiveControlObject:{
          justification:{required}
      }
    }
  },
  async created() {
    this.dataLoading = true;
    this.tabDataLoading = true;
    // await this.getAllRootKpis();
    await this.getAllUsers();
    // await this.getAllOrgControls();
    // await this.fetchKpisInfo();
    this.tabDataLoading = false;
    // emitter.off("activeControlPopup");
    // emitter.on('activeControlPopup', (data:any)=>{
    //   console.log('Data',data.entityData);
      
    // });
    				// emitter.emit('activeControlPopup', activeControlPopup);


    
    const savedTabKey = this.modalMode ? null : sessionStorage.getItem('selectedTab');
    if (savedTabKey) {
      const savedTab = this.carouselHead.find((tab: any) => tab.id == savedTabKey);
      if (savedTab) {
        await this.toggleTabs(savedTab.id);
      }
    } else {
      let matchedTab = this.currentType;
      if(matchedTab && matchedTab == 10102){
        await this.toggleTabs(0);
      }
      else if(matchedTab && matchedTab == 10103){
        await this.toggleTabs(1)
        this.calculateWeightAge(0);
      }
      else if (this.modalMode) {
        await this.toggleTabs(0);
      }
      
    }
    let routeControlId = this.currentControlId;
    let mainObj = this.allOrgControls.find((eachItem: any) => {
      return routeControlId == eachItem._id;
    });
    this.titleLength = mainObj?.controlTitle ? mainObj?.controlTitle.length : 0;
    this.dataLoading = false;
    this.routesArray = [
      { name: "Controls", routeName: "Controls" },
      { name: this.presentControlObj.clientUniqueId, routeName: "manageControlMap" },
    ];
    
    emitter.off('activiteToolTip');
    emitter.on('activiteToolTip', (data: any) => {
      this.toolTipActive = true;
      this.toolTipText = data.tipText;
    });
    emitter.off('deActiviteToolTip');
    emitter.on('deActiviteToolTip', (data: any) => {
      this.toolTipActive = false;
      this.toolTipText = '';
    });
  },
  async mounted(){
    // await this.fetchAllKpisInfo();
    // await this.fetchKpisInfo();
    emitter.off('deleteData');
    emitter.on('deleteData', (isData: any) => {
      this.showDeletePopUp(isData.entityData);
    });
  },
  computed: {
    ...mapGetters({
        userInfo:'userInfo',
        dbPriority:'dbPriority',
        dbFrequency: 'dbFrequency'
    }),
    currentControlId(): any {
      return this.controlId || this.$route.params.id;
    },
    currentType(): any {
      const fromProp = this.type != null && this.type !== '' ? this.type : this.$route.params.type;
      if (fromProp != null && fromProp !== '') {
        return fromProp;
      }
      return this.modalMode ? 10102 : fromProp;
    },
    
    isDuplicateData: function (): any {
      if(this.kpisListFromOrgPresentControl.length != 0 && this.hideFormula == true){        
        return {
          description: this.addedKpiNamesListExcludindSelectedKpi.some((kpi:any) =>{
            return this.addingKpiObj.description && kpi && JSON.stringify(kpi).replace(/\s+/g, '').toLowerCase() == JSON.stringify(this.addingKpiObj.description).replace(/\s+/g, '').toLowerCase();
          }),
        };
      } else if(this.hideFormula==false){
        
        this.allRootKpis.forEach((item: any) => {
          this.allRootKpisData.push(item.description)
        })        
        this.sortedAppliedKpisData.forEach((item: any) => {
          if(item.isActive==true){
            this.allRootKpisData.push(item.description)
          }
        })
        return {
          description: this.allRootKpisData.some((kpi:any) =>{
            return this.addingKpiObj.description && kpi && JSON.stringify(kpi).replace(/\s+/g, '').toLowerCase() == JSON.stringify(this.addingKpiObj.description).replace(/\s+/g, '').toLowerCase();
          }),
        };
      } else {
        return false;
      }
    },
    sortedData: function (): any {
      return [...this.allRootKpis]
        .filter((row: any) => {
          for (const key in this.filters) {
            const inputValue = this.filters[key];
            if (inputValue !== "" || row[key]) {
              if (Number(inputValue) && isNaN(row[key])) {
                if (!String(row[key]).includes(inputValue)) {
                  return false;
                }
              } else {
                if (
                  !row[key]
                    .toString()
                    .toLowerCase()
                    .includes(inputValue.toString().toLowerCase())
                ) {
                  return false;
                }
              }
            }
          }
          return true;
        })
        .sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === "desc") modifier = -1;
          if (this.currentSort === 'target' || this.currentSort === 'weightage') {
            const toNumeric = (val: any) => {
              if (val === 'N/A' || val == null || val === '') return Number.NEGATIVE_INFINITY;
              const num = Number(String(val).replace('%', '').trim());
              return isNaN(num) ? Number.NEGATIVE_INFINITY : num;
            };
            const aNum = toNumeric(a[this.currentSort]);
            const bNum = toNumeric(b[this.currentSort]);
            if (aNum < bNum) return -1 * modifier;
            if (aNum > bNum) return 1 * modifier;
            return 0;
          }
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        })
        .filter((row, index) => {
          this.dynamicPagination = index + 1;
          let start = (this.currentPage - 1) * this.pageSize;
          let end = this.currentPage * this.pageSize;
          if (index >= start && index < end) return true;
        });
    },
    widthClass() {
      return window.innerWidth >= 768 ? 'w-6/12' : 'w-full';
    },
    deactivatingKpiName(): string {
      const namesFromPending = (this.pendingFinalArr || [])
        .map((kpi: any) => kpi?.description)
        .filter((name: any) => name);
      if (namesFromPending.length) {
        return namesFromPending.join(', ');
      }
      const deselectedIds = this.defaultCheckedActiveKpis.filter(
        (id: any) => !this.checkedActiveKpis.includes(id)
      );
      const namesFromList = this.kpisListFromOrgPresentControl
        .filter((kpi: any) => deselectedIds.includes(kpi.referenceKpiId || kpi._id))
        .map((kpi: any) => kpi.description)
        .filter((name: any) => name);
      return namesFromList.join(', ') || 'N/A';
    },
    sortedAppliedKpisData: function (): any {
      this.dimmykpisListFromOrgPresentControl=[...this.kpisListFromOrgPresentControl]
      return [...this.kpisListFromOrgPresentControl]
        .filter((row: any) => {
          for (const key in this.filters) {
            const inputValue = this.filters[key];
            if (inputValue !== "" || row[key]) {
              if (Number(inputValue) && isNaN(row[key])) {
                if (!String(row[key]).includes(inputValue)) {
                  return false;
                }
              } else {
                if (
                  !row[key]
                    .toString()
                    .toLowerCase()
                    .includes(inputValue.toString().toLowerCase())
                ) {
                  return false;
                }
              }
            }
          }
          return true;
        })
        .sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === "desc") modifier = -1;          
          if(this.currentSort=='kpi_id'){
						const aVal = (a[this.currentSort] ?? '').toString();
						const bVal = (b[this.currentSort] ?? '').toString();
            const aNumMatch = aVal.match(/\d+$/);
            const bNumMatch = bVal.match(/\d+$/);
            if (aNumMatch && bNumMatch) {
                const aNum = parseInt(aNumMatch[0], 10);
                const bNum = parseInt(bNumMatch[0], 10);                
                if (aNum < bNum) return -1 * modifier;
                if (aNum > bNum) return 1 * modifier;
                return 0;
            }            
						if (aVal < bVal) return -1 * modifier;
						if (aVal > bVal) return 1 * modifier;
          }
          else if (this.currentSort === 'target' || this.currentSort === 'weightage') {
            const toNumeric = (val: any) => {
              if (val === 'N/A' || val == null || val === '') return Number.NEGATIVE_INFINITY;
              const num = Number(String(val).replace('%', '').trim());
              return isNaN(num) ? Number.NEGATIVE_INFINITY : num;
            };
            const aNum = toNumeric(a[this.currentSort]);
            const bNum = toNumeric(b[this.currentSort]);
            if (aNum < bNum) return -1 * modifier;
            if (aNum > bNum) return 1 * modifier;
            return 0;
          }
          else{          
            if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
            if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          }
          return 0;
        })
        .filter((row, index) => {
          
          this.dynamicPagination = index + 1;
          let start = (this.currentPage - 1) * this.pageSize;
          let end = this.currentPage * this.pageSize;
          if (index >= start && index < end) return true;
        });
    },
    disableStatus: function (): any {
      let output;
      if (this.editPop) {
        let objCopy = Object.assign({}, this.addingKpiObj);
        if (_.isEqual(objCopy, this.dummyObj)) {
          output = false;
        } else {
          output = true;
        }
      } else {
        if (_.isEqual(this.addingKpiObj, this.dummyObj)) {
          output = true;
        } else {
          output = false;
        }
      }
      return output;
    },
    arraysAreEqual: function (): any {
      const sortedArray1 = [...this.checkedActiveKpis].sort();
      const sortedArray2 = [...this.defaultCheckedActiveKpis].sort();
      
      if (sortedArray1.length !== sortedArray2.length) {
        return false;
      }

      for (let i = 0; i < sortedArray1.length; i++) {
        if (sortedArray1[i] !== sortedArray2[i]) {
          return false;
        }
      }

      return true;
    },
    filteredTimePeriods(): any {
      if (this.addingKpiObj.reportingFrequency) {
        return this.dbFrequency.filter(
          (value: any) => value.value >= this.addingKpiObj.reportingFrequency
        );
      } else {
        return [];
      }
    },
  },
  watch: {
    presentControlObj: {
      handler(obj: any) {
        if (this.modalMode && obj && obj.controlTitle) {
          this.$emit('header-info', { title: obj.controlTitle });
        }
      },
      deep: true,
    },
  },
  methods: {
    parseInProgressTasks(data: any): any[] {
      let parsed = data;
      if (typeof parsed === 'string') {
        const jsonStart = parsed.indexOf('[');
        if (jsonStart >= 0) {
          try {
            parsed = JSON.parse(parsed.slice(jsonStart));
          } catch {
            parsed = [];
          }
        } else {
          parsed = [];
        }
      }
      const list = Array.isArray(parsed)
        ? parsed
        : Array.isArray(parsed?.tasks)
          ? parsed.tasks
          : Array.isArray(parsed?.data)
            ? parsed.data
            : [];
      return list.map((task: any) => ({
        taskId: task?.taskId ?? task?.id ?? 'N/A',
        taskTitle: task?.taskTitle ?? task?.title ?? task?.TaskName ?? 'N/A',
        dueDate: task?.dueDate,
        plannerTaskId: task?.plannerTaskId,
        _id: task?._id,
        status: task?.status ?? task?.statusCode,
        statusCode: task?.statusCode ?? task?.status,
      }));
    },
    openInProgressTasksDialog(data: any) {
      const tasks = this.parseInProgressTasks(data);
      if (tasks.length === 0) {
        return;
      }
      this.inProgressTasks = tasks;
      this.dialogMessage = data;
      this.messageDialogMode = 'tasks';
      this.showMessageDialog = true;
    },
    onMessageDialogCancel() {
      this.showMessageDialog = false;
      this.messageDialogMode = 'confirm';
      this.inProgressTasks = [];
      this.pendingDeactivateRequest = null;
    },
    onMessageDialogOk() {
      this.showMessageDialog = false;
      this.messageDialogMode = 'confirm';
      this.dialogMessage = '';
      this.inProgressTasks = [];
    },
    async onMessageDialogOkTasks() {
      if (!this.pendingDeactivateRequest || this.inProgressTasks.length === 0) {
        this.onMessageDialogCancel();
        return;
      }
      const { scopeId, inactiveType, payload } = this.pendingDeactivateRequest;
      this.messageDialogMode = 'loading';
      try {
        await this.$http.post(
          `${process.env.VUE_APP_PLANNER_API}/api/org/active/controls/tasks/terminate`,
          {
            controlId: payload.controlId,
            tasks: this.inProgressTasks,
            updatedBy: this.userInfo._id,
            updatedAt: new Date(),
          }
        );
        const retryPayload = {
          ...payload,
          forceUpdate: true,
        };
        await this.$http.post(
          `${process.env.VUE_APP_MONITOR_API}/api/org/${scopeId}/${inactiveType}/control/inactive`,
          retryPayload
        );
        toast.info('Saved', {
          timeout: 1000,
          closeOnClick: true,
          closeButton: 'button',
          icon: true,
        });
        this.deActivatingPopup = false;
        const editObj: any = { ...retryPayload };
        delete editObj.controlId;
        editObj.justification = '';
        delete editObj.updatedBy;
        delete editObj.updatedAt;
        this.dummyDeActivateControlObject = { ...editObj };
        this.getAllOrgControls();
        const controlId = this.currentControlId;
        const obj: any = { ...retryPayload };
        if (this.controlsEditData.controlPriority != this.dummyControlObj.controlPriority) {
          obj.controlPriority = this.controlsEditData.controlPriority;
        }
        if (this.controlsEditData.controlFrequency != this.dummyControlObj.controlFrequency) {
          obj.controlFrequency = this.controlsEditData?.controlFrequency;
        }
        delete obj.justification;
        obj.updatedBy = this.userInfo._id;
        obj.updatedAt = new Date();
        await this.$http.post(
          `${process.env.VUE_APP_CONTROLS_API}/api/org/control/${controlId}/edit`,
          obj
        );
        if (this.selectedTabIndex == 0) {
          this.allActiveControls();
        }
        if (this.selectedTabIndex == 2) {
          this.getAllDeactivateControls();
        }
        this.controlEditPopup = false;
        delete obj.updatedBy;
        delete obj.activityId;
        delete obj.updatedAt;
        delete obj.controlId;
        this.dummyControlObj = { ...obj };
      } catch (e: any) {
        toast.error('Failed to terminate tasks or deactivate control', {
          timeout: 2000,
          closeOnClick: true,
          closeButton: 'button',
          icon: true,
        });
      } finally {
        this.showMessageDialog = false;
        this.messageDialogMode = 'confirm';
        this.dialogMessage = '';
        this.inProgressTasks = [];
        this.pendingDeactivateRequest = null;
      }
    },
    editControlPopup(){   
      if(this.selectedTabIndex==0){
        this.addControlpopup=false;
        this.controlEditPopup=true;
      }
    },
    
    isObjectEmpty(obj:any) {                 
            if(obj.justification==''){
              
                // if(obj.forceUpdate==false){
                //     return false;
                // }
                return Object.values(obj).some(val => val !== null && val !== undefined && val !== '');
            }
            // if(obj.justification=='' && obj.forceUpdate == false){                
            //     return true;
            // }
            return true;
        },
     getFrequencyValue(a:any){
        let val = this.controlFrequencyArray.find((item:any)=>{ return item.id == a });
        if(val != undefined){
            return val.label
        }else{
            return 'N/A'
        }
    },
     formatHistoryTime(time: any) {
          let now = moment(time);
          return now.format("DD-MM-YYYY, HH:mm:ss");
      },
    formatTime(time: any) {
      if(time!=undefined){
        let now = moment(time);
        return now.format("DD-MM-YYYY");
      }
      else{
        return 'N/A'
      }
      
    },
    extractInitials(name: any) {
        const names = name.split(" ");        
        return names
        .map((name: any) => name[0])
        .join("")
        .toUpperCase();
    },
     getPersonName(person: any) {        
        if (person == undefined) {
            return "";
        } else {
            return this.userInfo.name;
        }
    },
    sortWorkLog() {
      this.newHistory = !this.newHistory;
      this.workLogObject[0]?.history?.sort().reverse();
    },
     getControlFrequency(id:any){
      if((id != undefined || id != '' || id != null )&& this.dbFrequency && this.dbFrequency.length>0){
        let frequency:any = this.dbFrequency.find((data:any)=>{return data.value == id})
        return frequency.key
      } else {
        return 'N/A'
      }
     },
    async getControlHistory() {
            const id = this.currentControlId
            await this.$http
            .get(
            `${process.env.VUE_APP_CONTROLS_API}/api/org/controls/${id}/history`
            )
            .then((result: any) => {
            const mainObject = result.data;
            this.workLogObject = mainObject;
            });                  
            this.workLogObject[0]?.history?.sort().reverse();
        },
     colorLabelText(value: any) {
            if (value == 1) {
                return ["text-lightgreen font-semibold"];
            } else if (value == 2) {
                return ["text-green font-semibold"];
            } else if (value == 3) {
                return ["text-yellow font-semibold"];
            } else if (value == 4) {
                return ["text-error font-semibold"];
            } else if (value == 5) {
                return ["text-darkred font-semibold"];
            }
        },
        colorStatusText(value:any){
          if(value==1){
            return ["text-lightgreen font-semibold"];
          }
          else if(value==2){
            return ["text-error font-semibold"];
          }

        },
        colorLabelBg(value: any) {
            if (value == 1) {
                return ["bg-veryLowColor border-solid border border-lightgreen"];
            } else if (value == 2) {
                return ["bg-lowColor border-solid border border-green"];
            } else if (value == 3) {
                return ["bg-moderateColor border-solid border border-yellow"];
            } else if (value == 4) {
                return ["bg-highColor border-solid border border-error"];
            } else if (value == 5) {
                return ["bg-veryHighColor border-solid border border-darkred"];
            }
        },
        colorStatusBg(value:any){
           if (value == 1) {
                return ["bg-veryLowColor border-solid border border-lightgreen"];
          }
          else if (value == 2) {
              return ["bg-highColor border-solid border border-error"];
          }

        },
        getProirityLabel(val:any){
          if (val === 'N/A') { 
              return ''; 
          } else {
              let a = this.dbPriority.find((obj: any) => obj.value == val);
              return (val && typeof val === 'number') ? a.key : '';
          }
        },
        getStatusLabel(value:any){
          if(value=='N/A'){
            return ''
          }
          else{
            let a = this.activeValues.find((val:any)=>val.id == value);            
            return a!=undefined?a.value:''
          }
        },
     async getAllUsers() {
        await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
            this.users = res.data;
        });
        for (var i = 0; i < this.users.length; i++) {
            this.optionsUserArray.push({ label: this.users[i].name, value: this.users[i]._id });
        }
    },
    incrementAndAddKPI() {
            const maxCCNumber = this.allKpisList.reduce((max: number, item: any) => {
                if (typeof item === 'string' && item.startsWith('KPI-')) {
                const num = parseInt(item.split('-')[1]);
                if (!isNaN(num)) {
                    return Math.max(max, num);
                }
                }
                return max;
            }, 0);        
            const nextNumber = maxCCNumber + 1;
            const newKPIID = `KPI-${nextNumber}`;
            return newKPIID;
        },
    getOwnerName(name:any){      
      let matchedOwner = this.optionsUserArray.find((user:any)=>user.value==name);
      if(matchedOwner!=undefined){
        return matchedOwner.label
      }
      else{
        return 'N/A'
      }
      

    },
      async editCustomControl(obj:any,action:any){
            // !this.v$.customControlObject.$invalid
            this.v$.controlsEditData.$touch()
            
            if(action=='edit'){              
                if(!this.v$.controlsEditData.$invalid){
                  let checking = this.allControlsList.some((d:any)=>d.controlPriority!=obj.controlPriority);
                  let checking2 = this.allControlsList.some((d1:any)=>d1.controlFrequency!=obj.controlFrequency);                  
                obj.controlId = this.controlsData?._id;
                obj.updatedBy = this.userInfo._id;
                let activeControlId = this.currentControlId
                obj.updatedAt = new Date();
                if(this.allControlsList && this.allControlsList.length>0){
                  let matchedControl = this.allControlsList.find((control:any)=>control._id == activeControlId);
                  if(matchedControl!=undefined && matchedControl.activityId){
                    obj.activityId = matchedControl.activityId
                  }
                  else if(matchedControl!=undefined && matchedControl.systemId){
                    obj.systemId = matchedControl.systemId
                  }
                  else if(matchedControl!=undefined && matchedControl.projectId){
                    obj.projectId = matchedControl.projectId
                  }
                }
                // obj.activityId = this.currentControlId
                let controlId = this.currentControlId;                              
                try {
                  if(obj.isActive!== this.dummyControlObj.isActive && obj.isActive==false){
                    this.deActivatingPopup = true;
                    this.controlEditPopup = false;
                  }
                  else{
                     await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/api/org/control/${controlId}/edit`,obj).then((res:any ) => {
                    toast.info('Saved', {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    })
                     if(this.selectedTabIndex == 0){
                        this.allActiveControls();
                    }
                    if(this.selectedTabIndex == 2){
                        this.getAllDeactivateControls();
                    }
                    this.controlEditPopup = false;
                    delete obj.updatedBy;
                    delete obj.activityId;
                    delete obj.updatedAt;
                    delete obj.controlId;
                    this.dummyControlObj = {...obj}
                    });
                  }
                } catch (e) {                  
                    toast.error('error', {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                }
                
            }
            else{
                toast.error('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
                // this.controlEditPopup = false;
                
            }

            }
            else if(action=='deActive') {
            if(!this.v$.deActiveControlObject.$invalid){
                obj.controlId = this.presentControlObj?._id;
                obj.updatedBy = this.userInfo._id,
                obj.updatedAt = new Date()
                try {
                const activateControl = false;
                let id:any;
                let type:any;                
                if(this.presentControlObj.hasOwnProperty('activityId')){
                  id = this.presentControlObj.activityId
                  type = 10107
                }
                else if(this.presentControlObj.hasOwnProperty('systemId')){
                  id = this.presentControlObj.systemId
                  type = 10108
                }
                else{
                  id = this.presentControlObj.projectId
                  type = 10109
                }
                obj.isActive=false
                 let res = await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/${id}/${10102}/control/inactive`,obj).then((res:any ) => {
                // await this.$http.post(`${process.env.VUE_APP_MONITOR_API_URL}/api/org/control?activate=${activateControl}`,obj).then((res:any ) => {
                  toast.info('Saved', {
                      timeout: 1000,
                      closeOnClick: true,
                      closeButton: 'button',
                      icon: true
                  })
                  this.deActivatingPopup = false;
                  delete obj.controlId;
                  obj.justification='';
                  delete obj.updatedBy;
                  delete obj.updatedAt;
                  this.dummyDeActivateControlObject = {...obj};
                  this.getAllOrgControls();
                  // this.getActiveControlsForActivity();
              });
              let controlId = this.currentControlId;
              if(this.controlsEditData.controlPriority!=this.dummyControlObj.controlPriority){
                obj.controlPriority = this.controlsEditData.controlPriority
              }
              if(this.controlsEditData.controlFrequency!=this.dummyControlObj.controlFrequency){
                obj.controlFrequency = this.controlsEditData?.controlFrequency;
              }
              delete obj.justification;
              obj.updatedBy = this.userInfo._id,
              obj.updatedAt = new Date()                 
              await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/api/org/control/${controlId}/edit`,obj).then((res:any ) => {
                    // toast.info('Saved', {
                    //     timeout: 1000,
                    //     closeOnClick: true,
                    //     closeButton: 'button',
                    //     icon: true
                    // })
                     if(this.selectedTabIndex == 0){
                        this.allActiveControls();
                    }
                    if(this.selectedTabIndex == 2){
                        this.getAllDeactivateControls();
                    }
                    this.controlEditPopup = false;
                    delete obj.updatedBy;
                    delete obj.activityId;
                    delete obj.updatedAt;
                    delete obj.controlId;
                    this.dummyControlObj = {...obj}
                    });
      } catch (e:any) {
          if(e.response?.status==400){
              const scopeId = this.presentControlObj?.activityId
                || this.presentControlObj?.systemId
                || this.presentControlObj?.projectId;
              this.pendingDeactivateRequest = {
                scopeId,
                inactiveType: 10102,
                payload: { ...obj },
              };
              this.openInProgressTasksDialog(e.response.data);
          } else {
              toast.error('error', {
                  timeout: 1000,
                  closeOnClick: true,
                  closeButton: 'button',
                  icon: true
              });
          }
      }
  }else{
      toast.error('error', {
          timeout: 1000,
          closeOnClick: true,
          closeButton: 'button',
          icon: true
      });

  }
      
  }
  
    },
     onCancelbtnCustom(prop:any){
            this.v$.$reset();
            if (prop === 'close') {
                this.addpopup=false;
                this.addControlpopup=false;
                this.controlEditPopup = false;
                this.customPopup = false;
                // this.dummyCustomObj = {}
                this.controlsEditData={...this.dummyControlObj};
                this.presentControlObj={...this.dummyCustomObj};
			      }
            if(prop=='activecancel'){
                this.controlsEditData ={...this.dummyControlObj}
            }
            if(prop=='deactivateclose'){
                this.deActiveControlObject={justification:'',forceUpdate:''};
                this.deActiveKPIObject={justification:''};
                if (this.deActivatingKPIPopup) {
                  this.cancelActiveKpis();
                  this.pendingFinalArr = [];
                }
                this.deActivatingKPIPopup = false;
                this.deActivatingPopup = false;
                this.controlsEditData={...this.dummyControlObj}
            }
            if(prop=='deactivecancel'){
                // this.controlsEditData ={...this.dummyControlObj}
                this.deActiveControlObject={justification:'',forceUpdate:''};
                this.deActiveKPIObject={justification:''};
                this.controlsEditData={...this.dummyControlObj}
            }
            if(this.presentControlObj._id){
                this.presentControlObj = {...this.dummyCustomObj}
            }else{
                Object.keys(this.customControlObject).forEach((prop) => {
                Array.isArray(this.customControlObject[prop])
                    ? (this.customControlObject[prop] = [])
                    : (this.customControlObject[prop] = "");
                });
            }
            
        },
    showBlockAction(data: any, index: any) {
      if (this.showBlockindex === index) {
        this.showBlock = !this.showBlock;
      } else {
        this.showBlock = true;
        this.showBlockindex = index;
      }
      this.showDropdown = false;
    },
    toolTip(column: any, e: any, index: any, row: any, status: any) {      
      this.tipText = row[column];
      this.tipColumn = column;
      this.tipIndex = index;
      
      switch (status) {
        case 'text':
          this.handleTextTooltip(e);
          break;
        case 'circleButton':
					if(this.tipText == 1){            
                  let obj:any = {
                      tipText : 'Active'  
                  }
                    emitter.emit('activiteToolTip',obj)
          }else if(this.tipText == 0){            
                  let obj:any = {
                      tipText : 'Inactive'
                  }
                    emitter.emit('activiteToolTip',obj)
          }
					break;
      }
    },
    handleTextTooltip(e: any) {
      const container = e.currentTarget.closest('.table-ellipsis');
      if (container && this.isTextOverflowed(container)) {
        let obj:any = {
          tipText : this.tipText
        };
        emitter.emit('activiteToolTip', obj);
      } 
    },
    isTextOverflowed(element: any) {
      return element.scrollHeight > element.clientHeight;
    },
    sort(tableHead: any) {
      console.log('111',tableHead,this.currentSort);
      
      this.className = tableHead;
      if (tableHead === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = tableHead;
      this.classSort = this.currentSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
    },
    openPopup(data: any, index: any, actionBtn: any) {
      this.showBlockAction(data, index);
      let obj = {
        entityData: data,
        indexx: index,
        action: actionBtn
      };
    },
    async deSelectKpis(tabIndex:any, e: any){
      this.checkedActiveKpis = [];
      const checked = e.target.checked;      
      if (checked) {
        this.onSelectCheckBox = !this.onSelectCheckBox;
        for (let obj of this.kpisListFromOrgPresentControl) {
          let kpiObj:any = Object.keys(obj).includes('referenceKpiId') ? obj.referenceKpiId : obj._id;
          this.checkedActiveKpis.push(kpiObj);
        }
        this.AllRootKpis = [];
        this.showTotalKpisWeightage = 0;
        if(this.kpisListFromOrgPresentControl != undefined && Array.isArray(this.kpisListFromOrgPresentControl)){
          this.kpisListFromOrgPresentControl.map((obj: any) => {
            this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
          });
        }
      } else {        
        this.checkedActiveKpis = [];
        
        if (tabIndex == 1) {          
          const checked = e.target.checked;
          let weightage:any = 0;

          this.selectedRootKpis.map((data:any)=>{
            weightage += data.weightage;
          });
          this.showTotalKpisWeightage == 0 ? (this.showTotalKpisWeightage = 0) : '';
          await this.fetchAllKpisInfo();

          if (checked) {
            this.onSelectCheckBox = !this.onSelectCheckBox;
            this.showTotalKpisWeightage = this.showTotalKpisWeightage + weightage;
          } else {
            this.onSelectCheckBox = true;
            this.showTotalKpisWeightage = 0;
          }
        } else {
          this.showTotalKpisWeightage = 0;
          if(this.kpisListForPresentControl != undefined && Array.isArray(this.kpisListForPresentControl)){
            this.kpisListForPresentControl.map((obj: any) => {
              this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
            });
          }
          await this.fetchKpisInfo();
        }
      }
    },
    selectKpis(tabIndex:any, e: any){
      this.selectedRootKpis = [];
      const checked = e.target.checked;
      if (checked) {
        for (let obj of this.allRootKpis) {
          this.selectedRootKpis.push(obj);
        }
        if (tabIndex == 1) {
          const checked = e.target.checked;
          let weightage:any = 0;
          this.selectedRootKpis.map((data:any)=>{
            weightage += data.weightage;
          });
          this.showTotalKpisWeightage == 0 ? (this.showTotalKpisWeightage = 0) : '';

          if (checked) {
            this.showTotalKpisWeightage = this.showTotalKpisWeightage + weightage;
          } else {
            this.showTotalKpisWeightage = this.showTotalKpisWeightage - weightage;
          }
        } else {
          this.showTotalKpisWeightage = 0;
          if(this.kpisListFromOrgPresentControl != undefined && Array.isArray(this.kpisListFromOrgPresentControl)){
            
            this.kpisListFromOrgPresentControl.map((obj: any) => {
              this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
            });
          }
        }
      } else {
        this.selectedRootKpis = [];
        this.showTotalKpisWeightage = 0;
        if(this.kpisListFromOrgPresentControl != undefined && Array.isArray(this.kpisListFromOrgPresentControl)){
          this.kpisListFromOrgPresentControl.map((obj: any) => {
            
            this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
          });
        }
      }
    },
    changedActiveKpiInput(tabIndex: any, e: any, weightage: any){
      if (tabIndex == 0) {
        const checked = e.target.checked;
        this.showTotalKpisWeightage == 0 ? (this.showTotalKpisWeightage = 0) : '';
        if (checked) {
          this.onSelectCheckBox = !this.onSelectCheckBox;
          this.showTotalKpisWeightage = this.showTotalKpisWeightage + weightage;
        } else {
          this.onSelectCheckBox = true;
          this.showTotalKpisWeightage = this.showTotalKpisWeightage - weightage;
        }        
        if(this.checkedActiveKpis.length == this.kpisListFromOrgPresentControl.length){
          this.selecteAllActiveKpis = true;
        }else{
          this.selecteAllActiveKpis = false;
        }
      } else {
        this.showTotalKpisWeightage = 0;
        if(this.kpisListForPresentControl != undefined && Array.isArray(this.kpisListForPresentControl)){
          this.kpisListForPresentControl.map((obj: any) => {
            
            this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
          });
        }
      }
      },
    cancelActiveKpis(){
      this.checkedActiveKpis = [...this.defaultCheckedActiveKpis];
      this.showTotalKpisWeightage=0; 
      this.onSelectCheckBox = false;
      if(this.checkedActiveKpis.length == this.kpisListFromOrgPresentControl.length){
        this.selecteAllActiveKpis = true;
      } else {
        this.selecteAllActiveKpis = false;
      }      
      if(this.kpisListFromOrgPresentControl != undefined && Array.isArray(this.kpisListFromOrgPresentControl)){
				this.kpisListFromOrgPresentControl.map((obj: any) => {
          if(obj.isActive==true){
					  this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
          }
          
				});
			}

    },
    cancelRelatedKpis(){
      this.selectedRootKpis = [];
      this.selecteAllRelatedKpis = false;
      this.showTotalKpisWeightage = 0;
      if(this.kpisListFromOrgPresentControl != undefined && Array.isArray(this.kpisListFromOrgPresentControl)){
        this.kpisListFromOrgPresentControl.map((obj: any) => {
          
          this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
        });
      }
    },
    getColumnHeadWidth(column:any){       
      if(column == 'description'){
        return 'w-[20%]'
      }     
      else if(column == 'kpiType'||column=='kpi_id'){
        return 'w-[10%]';
      }
      else if(column=='status'||column=='target'){
        return 'widthFivePercent'
      }
      else if(column=='updatedon' || column=='weightage'){
        return 'w-[10%]'
      }
      // else if(column == 'weightage'){
      //   return 'widthFivePercent'
      // }
    },
    formatKpiTargetForDisplay(kpi: any) {
      if (kpi?.target == null || kpi.target === "") return "N/A";
      const targetType = kpi.targetType || "percentage";
      const numeric = Number(String(kpi.target).replace("%", "").trim());
      if (isNaN(numeric)) return "N/A";
      if (targetType === "number") {
        return String(numeric);
      }
      return `${numeric}%`;
    },
    deleteAndShowRowData(sortedData:any, index:any) {
      this.kpiList.splice(index, 1);
    },
    showTotalKpisWeightageLessThan100() {
      let totalWeightage = 0;
      return totalWeightage + this.addingKpiObj.weightage < 100;
    },
    emptyTargetTimePeriod(kpi: any) {
      if (kpi.targetTimePeriod < kpi.reportingFrequency) {
        kpi.targetTimePeriod = "";
      }
    },
    async deleteKpiForControl(kpiObj: any){
      await this.$http
        .delete(
          `${process.env.VUE_APP_CONTROLS_API}/api/org/control/${this.currentControlId}/kpi/${kpiObj._id}/delete`
        )
        .then(async () => {
          toast.info("Deleted", {
            timeout: 5000,
            closeOnClick: true,
            closeButton: "button",
            icon: true,
          });
          this.selectedRootKpis = [];
          await this.fetchKpisInfo();
          await this.getAllOrgControls();
          await this.toggleTabs(0);
          this.showPopup = false;
        });
    },
    async fetchKpisInfo() {
      this.allRootKpis = [];      
      this.tableRow = [];
      this.tableLoading = true; // Show table loading state      
      if(this.presentControlObject.rootFrameWork || this.presentControlObject.classificationType==3){
        try {
          await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls/${this.presentControlObject._id}/relatedkpis/get`).then((result: any) => {
            this.isLoading = true;
            this.showLoader = true;
            this.allRootKpis = result.data;
            if(this.allRootKpis != undefined || this.allRootKpis != null){
              this.dummyList = this.allRootKpis;
            } else {
              // console.log("this.allRootKpis",this.allRootKpis);
            }
          });
        } catch (e) {
          toast.error('error', {
            timeout: 1000,
            closeOnClick: true,
            closeButton: 'button',
            icon: true
          });
        }
      }
      this.showLoader = false;
      this.tableLoading = false; // Hide table loading state
    },
    async makeTable() {
      this.tableLoading = true; // Show table loading state
      if (this.allRootKpis.length > 0) {
        this.allRootKpis.forEach(async (eachKPI: any) => {
          
          let finalKPIObj: any = {
            'KPI Name': eachKPI.description,
            'Weightage (%)': parseInt(eachKPI.weightage),
            'Target': this.formatKpiTargetForDisplay(eachKPI)
          };
          await this.tableRow.push(finalKPIObj);
          this.dataLoading = false;
        });
      } else {
        let finalKPIObj = {
          'KPI Name': '',
          'Weightage (%)': '',
          'Target':''
        };
        await this.tableRow.push(finalKPIObj);
        this.dataLoading = false;
      }
      this.tableLoading = false; // Hide table loading state
    },
   async addKPI() {
      this.buttonVisible = true;
      // if (this.kpisListFromOrgPresentControl.length < 10) {
        let numeric = 0;
        //previous logic
        // this.allKpisList.forEach((item: any) => {
        //   console.log('ggg',item);
        //   if (item.kpi_id) {
        //     const parts = item.kpi_id.split(" ");
        //     console.log('parts',parts);          
        //     if (parts.length > 2) {
        //       const intNumber = parseInt(parts[2]);
        //       console.log('lll',intNumber);             
        //       if (!isNaN(intNumber)) {
        //         console.log('aaaa');      
        //         numeric = Math.max(numeric, intNumber);
        //         console.log('bbb',numeric);
        //       }
        //     }
        //   }
        // });
        // numeric++; // Increment numeric outside the loop to get the next KPI number
        // let id = "KPI - " + numeric;
        //updated above logic to continue kpi_id series count
      this.allKpisList.forEach((item: any) => {
        if (item.kpi_id) {
          const parts = item.kpi_id.split("-");
          if (parts.length > 1) {
            const intNumber = parseInt(parts[1]);
            if (!isNaN(intNumber)) {
              numeric = Math.max(numeric, intNumber);
            }
          }
        }
      });
      numeric++;
      let id = "KPI-" + numeric;
        this.addingKpiObj = { kpi_id: id, weightage: "", description: "", target: "", kpiCondition: "", targetType: null };
        this.hideFormula = false;
        this.showPopup = true;
        this.editPop = false;
        this.dummyObj = { ...this.addingKpiObj };
      // }
    },
    async getAllSystems() {
        let entityId='20005'
        await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${entityId}`).then((res: any) => {
            this.systems = res.data;
        });
    },
    async fetchActivitiesList() {
      await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/processes/mappedcontrols/count`).then((res: { data: any }) => {
          this.activitiesList = res.data;
      });
    },
    async getAllProjects(){
			this.projectDataArray = [],
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/projects/getAll`).then((res: any) => {
          this.allProjects = res.data;
      })},
      async allActiveControls() {
        await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls`).then((res: any) => {
            this.allControlsList = res.data;
            this.presentControlObj =this.allControlsList.find((control:any)=>control._id == this.currentControlId);
            let tierName: any;
            let tierTitle = '';
            const keysOfObject = Object.keys(this.presentControlObj);
            const getTierData = (id: number) => {
                const tier =this. ObjectIncludedTier.find((item:any) => item.id === id);
                return tier!=undefined && tier!='' ? tier.value : 'N/A'; 
            };
            if (keysOfObject.includes('activityId')) {
                tierName = getTierData(10107);
                if (this.activitiesList.length > 0 && this.presentControlObj.activityId != undefined) {
                    let matchedActivity = this.activitiesList.find((activity: any) => activity._id.toString() == this.presentControlObj.activityId.toString());
                    if (matchedActivity != undefined) {
                        tierTitle = matchedActivity.businessProcessName;
                    }
                }
            } else if (keysOfObject.includes('systemId')) {
                tierName = getTierData(10108);
                if (this.systems.length > 0 && this.presentControlObj.systemId != undefined) {
                    let matchedSystem = this.systems.find((sys: any) => sys._id.toString() == this.presentControlObj.systemId.toString());
                    if (matchedSystem != undefined) {
                        tierTitle = matchedSystem.systemName;
                    }
                }
            } else if (keysOfObject.includes('projectId')) {
                tierName = getTierData(10109);
                if (this.allProjects.length > 0 && this.presentControlObj.projectId != undefined) {
                    let matchedProject = this.allProjects.find((project: any) => project._id.toString() == this.presentControlObj.projectId.toString());
                    if (matchedProject != undefined) {
                        tierTitle = matchedProject.projectName;
                    }
                }
            } else {
                tierTitle = 'N/A'; 
            }
            this.presentControlObj.tierTitle = tierTitle;
            this.presentControlObj.tier = tierName;
            this.dummyCustomObj = { ...this.presentControlObj };
            this.controlsEditData.controlPriority = this.presentControlObj.controlPriority;
            this.controlsEditData.controlFrequency = this.presentControlObj.controlFrequency;
            this.controlsEditData.isActive=this.presentControlObj.isActive
            this.dummyControlObj={...this.controlsEditData };
            
        });
    },
    onReset() {
      // reset form validation errors
      this.v$.$reset();
      // reset form data
      const initialData = this.$options.data.call(this);
      Object.assign(this.$data, initialData);
    },
    showEditPopUp(showObj: any, column: any) {
      if(column != 'deleteIcon'){
        this.v$.$reset();
        this.showPopup = true;
        this.editPop = true;
        this.addedKpiNamesListExcludindSelectedKpi=[];
        this.kpisListFromOrgPresentControl.forEach((data:any) => {
          if(showObj._id != data._id){
            this.addedKpiNamesListExcludindSelectedKpi.push(data.description);
          }
        });
        let kpiId= this.incrementAndAddKPI();     
        this.addingKpiObj.kpiId = kpiId;  
        
        this.addingKpiObj = {
          ...showObj,
          kpiCondition: showObj.kpiCondition || showObj.targetOperator || showObj.logic || "",
          targetType: showObj.targetType || "percentage",
        };
        delete this.addingKpiObj.targetOperator;
        delete this.addingKpiObj.logic;
        this.dummyObj = { ...this.addingKpiObj };
        this.hideFormula = true;
        this.buttonVisible = true;
      }
    },
    filterOpen(){
             this.showFilters = !this.showFilters;
                if (this.showFilters == true) {
                    this.dimmykpisListFromOrgPresentControl = this.kpisListFromOrgPresentControl;
                } else {
                    this.kpisListFromOrgPresentControl = this.dimmykpisListFromOrgPresentControl;
                        this.filters = {};
                }
        },
    paginationUpdations(currentPage: any, pageSize: any) {
      this.currentPage = currentPage;
      this.pageSize = pageSize;
    },
    onCancelbtn() {
      this.v$.$reset();
      this.validtaionWeightageError = false;
      this.validTargetError=false;
      this.numberLessThanZero = false;
      this.targetNumberLessThanZero=false;
      if (!this.addingKpiObj._id) {
        Object.keys(this.addingKpiObj).forEach((prop) => {
          if (prop != "kpi_id") {
            Array.isArray(this.addingKpiObj[prop])
              ? (this.addingKpiObj[prop] = [])
              : (this.addingKpiObj[prop] = "");
          }
        });
        this.hideFormula = false;
      } else {
        this.addingKpiObj = { ...this.dummyObj };
      }
    },
    addRelatedKPIs() {
      if (this.appliedKPIs.length + this.relatedKPIs.length > 10) {
        this.$toast.error('You can only have a maximum of 10 KPIs.');
        return;
      }
      
      // Add related KPIs to appliedKPIs array
      this.appliedKPIs.push(...this.relatedKPIs);
      
      // Clear the selection or reset relatedKPIs array
      this.relatedKPIs = [];
    },
    async getAllRootControls() {
      this.kpisListForPresentControl = [];
      try {
        await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/root/controls/getall`).then((result: { data: any }) => {
          this.allControls = result.data;
          let routeControlId = this.currentControlId;
          let mainObj = result.data.find((eachItem: any) => {
            return routeControlId == eachItem._id;
          });
          if (mainObj != undefined && Object.keys(mainObj).includes('kpis')) {
            this.kpisListForPresentControl = mainObj.kpis;

            let mappedKpis: any = [];
            this.kpisListForPresentControl.map((obj: any) => {
              mappedKpis.push(obj.description);
            });

            if (mappedKpis.length > 0) {
              let filteredRootKpis = this.allRootKpis.filter((obj: any) => {
                return !mappedKpis.includes(obj.description);
              });
              this.allRootKpis = filteredRootKpis;
            }
          } else {
            this.kpisListForPresentControl = [];
          }
        });
      } catch (e) {
        toast.error('error', {
          timeout: 1000,
          closeOnClick: true,
          closeButton: 'button',
          icon: true
        });
      }
    },
    widthofTabStructure(){
      return window.innerWidth >= 768;
    },
    async getAllOrgControls() {
      this.tabDataLoading = true;
      this.presentControlObject = {};
      this.kpisListFromOrgPresentControl = [];
      
      try {
        await this.$http
          .get(
            `${process.env.VUE_APP_CONTROLS_API}/api/org/controls`
          )
          .then(async (result: { data: any }) => {
            this.allOrgControls = result.data;
            let routeControlId = this.currentControlId;
            let mainObj = result.data.find((eachItem: any) => {
              return routeControlId == eachItem._id;
            });
            this.presentControlObj = mainObj
            if(mainObj != undefined){
              this.presentControlObject = mainObj;
            }
            if (mainObj != undefined && Object.keys(mainObj).includes("kpis")) {
              this.kpisListFromOrgPresentControl = mainObj.kpis;

              let mappedKpis: any = [];
              
              this.kpisListFromOrgPresentControl.map((obj: any) => {
                // this.disabledKpis;
                if (!obj.kpi_id || obj.kpi_id == '') {
                    obj.kpi_id = this.incrementAndAddKPI();
                }
                if(obj.hasOwnProperty('isActive')){
                  obj.status=obj.isActive
                }
                else{
                  obj.status=false
                }
                if(obj.isActive==true){
                  mappedKpis.push(obj.description)
                }                
                if(mappedKpis.length>0){
                  this.disabledKpis = mappedKpis;
                }
                obj.updatedon=obj.updatedAt;
              });
              if (mappedKpis.length > 0) {
                if(this.allRootKpis !== undefined || this.allRootKpis !== null){
                  let filteredOrgKpis =
                    this.allRootKpis.filter((obj: any) => {
                      return !mappedKpis.includes(obj.description);
                    });
                  this.allRootKpis = filteredOrgKpis;
                }else{
                  // console.log("this.allRootKpis",this.allRootKpis);
                }
                
              }
            } else {
              this.kpisListFromOrgPresentControl = [];
            }
            await this.makeTable();
          });
      } catch (e) {
        toast.error("Error", {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
      }
      this.tabDataLoading = false;
    },
    doFalse() {
      emitter.emit('deActiviteToolTip');
    },
    async fetchAllKpisInfo() {      
      this.checkedActiveKpis = [];
      this.defaultCheckedActiveKpis = [];
      this.addedKpiNamesList = [];
      try {
        await this.$http
          .get(`${process.env.VUE_APP_CONTROLS_API}/api/org/active/kpis/getall`)
          .then((result: { data: any }) => {
            result.data.forEach((eachKpi: any) => {
              if (eachKpi.kpis && eachKpi.kpis.length) {
                this.allKpisList.push(...eachKpi.kpis);
                eachKpi.kpis.forEach((data:any)=>{  
                    if(data.isActive==true){
                        let keyOfObject:any = Object.keys(data).includes('referenceKpiId') ? data.referenceKpiId : data._id;
                    this.addedKpiNamesList.push(data.description);
                    
                    if(this.kpisListFromOrgPresentControl.length == 0){
                      if (!this.checkedActiveKpis.includes(keyOfObject)) {
                        this.checkedActiveKpis.push(keyOfObject);
                      }
                      if (!this.defaultCheckedActiveKpis.includes(keyOfObject)) {
                        this.defaultCheckedActiveKpis.push(keyOfObject);
                      }
                    }
                    else if(this.kpisListFromOrgPresentControl.length > 0){
                      this.sortedAppliedKpisData.forEach((data:any)=>{
                        let sortedAppliedKpi:any = Object.keys(data).includes('referenceKpiId') ? data.referenceKpiId : data._id;
                        
                        if (!this.checkedActiveKpis.includes(sortedAppliedKpi)) {
                          this.checkedActiveKpis.push(sortedAppliedKpi);
                        }

                        if (!this.defaultCheckedActiveKpis.includes(sortedAppliedKpi)) {
                          this.defaultCheckedActiveKpis.push(sortedAppliedKpi);
                        }
                        

                      });
                      
                    }                  
                    if(this.checkedActiveKpis.length == this.kpisListFromOrgPresentControl.length&& this.kpisListFromOrgPresentControl.length!=0){
                        this.selecteAllActiveKpis = true;
                      } else {
                        this.selecteAllActiveKpis = false;
                      } 

                    }
                                   
                });
              }
            });
          });
      } catch (e) {
        toast.error("error", {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
      }
    },
    async toggleTabs(navIndex: any) {
      
      this.dataLoading = false;
      this.tabDataLoading = true; // Show tab-specific loading state
      this.tableLoading = true; // Show table loading state
      
      this.selectedTabIndex = navIndex;
      this.calculateWeightAge(0);
      this.selectedRootKpis = [];
      this.filters = {};
      this.showFilters = false;
      //sessionStorage.setItem('selectedTab', navIndex);
      
      if(navIndex==0) {
        this.selecteAllRelatedKpis = false;
        let activeKpis:any=[];
        let sortedkpis = this.sortedAppliedKpisData.find((kpi:any)=>{
          if(kpi.isActive==true){
            activeKpis.push(kpi.isActive)
          }
        })
        this.getAllSystems();
        this.fetchActivitiesList();
        this.getAllProjects();
        await this.allActiveControls(); 
      }
      if(navIndex==1){
        await this.fetchAllKpisInfo(); 
        await this.getAllOrgControls();
        this.calculateWeightAge(0);
        // await this.allActiveControls();
      }
      if(navIndex==2){
        await this.getControlHistory();
      }
      
      // Simulate API delay for tab switching
      setTimeout(() => {
        this.tabDataLoading = false;
        this.tableLoading = false;
      }, 800);
    },
    newWeightage(kpiObj: any, previousWeightage: number = 0) {
      const totalWeightage = this.showTotalKpisWeightage - previousWeightage + kpiObj.weightage;
      return totalWeightage;
    },
    handleInput(event : any) {
      this.addingKpiObj.weightage = event.target.value.replace(/[^\d]/g, '');
    },
    handleTargetInput(event:any) {
      this.addingKpiObj.target = event.target.value.replace(/[^\d]/g, '');
    },
    weightageLessThanZero(weightage : any){
      if(weightage < 0 || weightage == 0){
        this.numberLessThanZero = true;
      }else{
        this.numberLessThanZero = false;
      }
    },
    targetLessThanZero(value:any){
      if(value < 0){
        this.targetNumberLessThanZero = true;
      }else{
        this.targetNumberLessThanZero = false;
      }
    },
    weightageGreaterThanZero(kpi: any){
      if (String(kpi.weightage).includes('.')) {
        this.validtaionWeightageError = true;
        return;
      }
      this.validtaionWeightageError = false;
      let previousWeightage = 0;
      let kpiId = kpi._id;
      if (kpiId){
        const existingKpi = this.kpisListFromOrgPresentControl.find((eachKPI: any) => eachKPI._id === kpiId && eachKPI.isActive==true);
        if (existingKpi) {
          previousWeightage = existingKpi.weightage;
        }
      }
      const valid = this.newWeightage(kpi, previousWeightage);
      if (valid <= 100) {
        this.validtaionWeightageError = false;
      }else {
        this.validtaionWeightageError = true;
      }
    },
    targetGreaterThanZero(value: any){
     if (String(value).includes('.')) {
        this.validTargetError = true;
        return;
      }
      this.validTargetError = false;
      if (this.addingKpiObj.targetType === "number") {
        this.validTargetError = false;
        return;
      }
      if (value <= 100) {
        this.validTargetError = false;
      }else {
        this.validTargetError = true;
      }
    },
    async addOrUpdateKpiForControlManual(kpi: any) {
      this.v$.addingKpiObj.$touch();
      let check:any = !Object.values(this.isDuplicateData).includes(true);
      if (!this.v$.addingKpiObj.$invalid && this.numberLessThanZero == false && this.targetNumberLessThanZero==false && this.validtaionWeightageError == false && this.validTargetError==false && check) {
        this.clickOnButton = true;
        let previousWeightage = 0;
        let kpiId = kpi._id;

        if (kpiId) {
          // Find the previous weightage if KPI is being updated
          const existingKpi = this.kpisListFromOrgPresentControl.find((eachKPI: any) => eachKPI._id === kpiId);
          if (existingKpi) {
            previousWeightage = existingKpi.weightage;
          }
        }

        const valid = this.newWeightage(kpi, previousWeightage);

        if (valid <= 100) {
          if (kpiId) {
            // Update the KPI
            await this.updateKpiForControl(kpi);
          } else {
            // Add new KPI
            this.showPopup = false;
            await this.saveKpisForPresentOrgControl(kpi, 'manual');
          }
          this.showPopup = false;
          
          // Update showTotalKpisWeightage
          this.showTotalKpisWeightage = valid;

          this.v$.$reset();
        }
      }
    },
    async saveKpisForPresentOrgControl(kpiObj: any, action: any) {    
      let finalArr: any[] = [];
      let totalWeightage = 0;
      this.clickOnButton = true;
      let payload:any=[];
      
      if (action === 'manual') {
        // totalWeightage = this.showTotalKpisWeightage + kpiObj.weightage;        
        this.clientCustomKpi = true;
        kpiObj.isActive=true;
      } else if (action === 'direct') {
        this.clientCustomKpi = false;
        
        totalWeightage = this.showTotalKpisWeightage;
      }
      
      if (totalWeightage <= 100) {
        if (this.selectedTabIndex == 2) {
          this.selectedRootKpis.map((obj: any) => {
            let numeric = 1;
            this.allKpisList.forEach((item: any) => {
              if (item.kpi_id) {
                const parts = item.kpi_id.split(" ");
                if (parts.length > 2) {
                  const intNumber = parseInt(parts[2]);
                  if (!isNaN(intNumber)) {
                    numeric = Math.max(numeric, intNumber);
                  }
                }
              }
            });
            numeric++; // Increment numeric outside the loop to get the next KPI number
            let id = "KPI - " + numeric;
            obj.kpi_id = id;
            if(this.clientCustomKpi != true && (obj.kpiType==2 || obj.kpiType == 3)) {
              obj.referenceKpiId = obj._id;
              delete obj._id;
            }
            // obj.referenceKpiId = obj._id;
            delete obj._id;
            finalArr.push(obj);
          });
        } 
        else {          
          kpiObj.updatedBy = this.userInfo._id;
          kpiObj.updatedAt = new Date();
          kpiObj.target = Number(kpiObj.target);
          finalArr.push(kpiObj);
        }
        
        try{
          if(this.clientCustomKpi == true) {

            await this.$http
              .post(
                `${process.env.VUE_APP_CONTROLS_API}/api/org/control/${this.currentControlId}/kpis/add?control=true`,
                finalArr
              )
              .then(async () => {
                toast.info("Saved", {
                  timeout: 5000,
                  closeOnClick: true,
                  closeButton: "button",
                  icon: true,
                });
                await this.getAllOrgControls();
                // await this.fetchKpisInfo();
                this.selectedRootKpis = [];
                await this.toggleTabs(0);
                this.onSelectCheckBox = false;
                this.buttonVisible=false;
                this.showPopup = false;
                await this.fetchAllKpisInfo();
              });
          }
          else {
            await this.$http
              .post(
                `${process.env.VUE_APP_CONTROLS_API}/api/org/control/${this.currentControlId}/kpis/add`,
                finalArr
              )
              .then(async () => {
                toast.info("Saved", {
                  timeout: 5000,
                  closeOnClick: true,
                  closeButton: "button",
                  icon: true,
                });
                await this.fetchKpisInfo();
                await this.getAllOrgControls();
                await this.fetchAllKpisInfo();
                await this.toggleTabs(0);
                this.onSelectCheckBox = false;
                this.buttonVisible=false;
                this.showPopup = false;
              });
          }
        }catch(e){
          toast.error(`cannot Save`, {
            timeout: 1000,
            closeOnClick: true,
            closeButton: 'button',
            icon: true
          });
        }finally{
          this.clickOnButton = false;
        }
      } 
      else if (action === 'direct') {        
        toast.error("Total Weightage should be less than 100", {
          timeout: 5000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
        this.clickOnButton = false;
      }
      this.showPopup = false;
    },
    async saveKpisForControl(kpiObj: any, action: any) {
      // if(kpiObj.hasOwnProperty('isActive')){
      //     kpiObj.isActive=true;
      // }
      // console.log('kpiObj',kpiObj);
      this.deActiveKPIObject={justification:''};
      let finalArr: any[] = [];
      let totalWeightage = 0;
      this.clickOnButton = true;
      let payload:any=[];
      kpiObj.updatedBy = this.userInfo._id;
      kpiObj.updatedAt=new Date();
      if(this.deActiveKPIObject.justification!=undefined){
        kpiObj.justification = this.deActiveKPIObject.justification
      }
      
      if (totalWeightage <= 100) {
        this.deActivatingKPIPopup = true;
        if(this.selectedTabIndex == 1){
          let deselectedControls:any = this.defaultCheckedActiveKpis.filter((id:any) => !this.checkedActiveKpis.includes(id));
          
          if(deselectedControls != undefined && deselectedControls.length != 0){
            let kpisData = JSON.parse(JSON.stringify(this.kpisListFromOrgPresentControl));
            kpisData.forEach((kpiData:any) => {
              const kpiId = kpiData.hasOwnProperty('referenceKpiId') ? kpiData.referenceKpiId : kpiData._id;
              // if(!Object.keys(kpiData).includes('isActive')){
              //   kpiData.isActive=false;                
              // }
               if(!Object.keys(kpiData).includes('isActive')|| Object.keys(kpiData).includes('isActive')){
                kpiData.isActive=false;                
              }
              kpiData.updatedBy=this.userInfo._id;
              kpiData.updatedAt = new Date();
              delete kpiData.status;
              kpiData.updatedBy=this.userInfo._id;
              kpiData.updatedAt = new Date();
              delete kpiData.updatedon;      
              // delete kpiData.status;              
              deselectedControls.map((data:any)=>{
                if(data == kpiId){
                  finalArr.push(kpiData);
                }
              });
            });
          }
        }
        else {
          kpiObj.updatedBy=this.userInfo._id;
          kpiObj.updatedAt=new Date();   
          delete kpiObj.updatedon;      
          finalArr.push(kpiObj);
        } 
        if (finalArr.length > 0) {
          this.pendingFinalArr = finalArr;   // store for popup
          this.deActivatingKPIPopup = true;  // open popup
          this.clickOnButton = false;
          return;                            
        }       
        // try{
        //   console.log('finalArr',finalArr);
          
        //   await this.deactivateKpi(kpiObj,finalArr);
         
        // }catch(e){
        //   toast.error(`cannot Save`, {
        //     timeout: 1000,
        //     closeOnClick: true,
        //     closeButton: 'button',
        //     icon: true
        //   });
        // }finally{
        //   this.clickOnButton = false;
        // }
      } 
      else if (action === 'direct') {        
        toast.error("Total Weightage should be less than 100", {
          timeout: 5000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
        this.clickOnButton = false;
      }
      this.showPopup = false;
    },
    // async deactivateKpi(justification:any,finalArr:any){
    //   console.log('justification',justification,finalArr);
      
    //   finalArr[0].justification = justification
    //    if(this.selectedTabIndex==1 && !this.v$.deActiveKPIObject.$invalid) {
    //     console.log('finalArr',finalArr);
        
    //         // await this.$http
    //         //   .post(
    //         //     `${process.env.VUE_APP_CONTROLS_API}/api/org/control/${this.currentControlId}/kpis/select`,
    //         //     finalArr
    //         //   )
    //         //   .then(async () => {
    //         //     toast.info("Saved", {
    //         //       timeout: 5000,
    //         //       closeOnClick: true,
    //         //       closeButton: "button",
    //         //       icon: true,
    //         //     });
    //         //     this.deActivatingKPIPopup = false;
    //         //     this.selectedRootKpis = [];
    //         //     this.disabledKpis=[];
    //         //     // await this.toggleTabs(0);
    //         //     await this.getAllOrgControls();
    //         //     await this.fetchAllKpisInfo();
    //         //     // await this.fetchKpisInfo();
    //         //     this.onSelectCheckBox=false;
    //         //     this.ediKpi=false;
               
    //         //     this.buttonVisible=false;
    //         //     this.showPopup = false;
    //         //     this.v$.deActiveKPIObject.$reset();
    //         //   });
    //       }
    // },
      async confirmDeactivateKpis() {
      this.v$.deActiveKPIObject.$touch();
      // Add justification to the already-built finalArr
      this.pendingFinalArr.forEach((kpi: any) => {
        kpi.justification = this.deActiveKPIObject.justification;
      });
       if(this.selectedTabIndex== 1 && !this.v$.deActiveKPIObject.$invalid) {
        console.log('finalArr',this.pendingFinalArr);
        try{
            await this.$http
              .post(
                `${process.env.VUE_APP_CONTROLS_API}/api/org/control/${this.currentControlId}/kpis/select`,
                this.pendingFinalArr
              )
              .then(async () => {
                toast.info("Saved", {
                  timeout: 5000,
                  closeOnClick: true,
                  closeButton: "button",
                  icon: true,
                });
                this.deActivatingKPIPopup = false;
                this.selectedRootKpis = [];
                this.disabledKpis=[];
                // await this.toggleTabs(0);
                await this.getAllOrgControls();
                await this.fetchAllKpisInfo();
                // await this.fetchKpisInfo();
                this.onSelectCheckBox=false;
                this.ediKpi=false;
               
                this.buttonVisible=false;
                this.showPopup = false;
                this.v$.deActiveKPIObject.$reset();
              });
          }catch(e) {
            toast.error("cannot Save", {
              timeout: 1000,
              closeOnClick: true,
              closeButton: 'button',
              icon: true
            });
          }finally{
          this.clickOnButton = false;
          }
        }
  },
    calculateWeightAge(tabIndex: any, e: any, weightage: any) {
      if (tabIndex == 1) {
        const checked = e.target.checked;
        this.showTotalKpisWeightage == 0
          ? (this.showTotalKpisWeightage = 0)
          : "";
          
        if (checked) {
          
          this.showTotalKpisWeightage = this.showTotalKpisWeightage + weightage;
        } else {
          
          this.showTotalKpisWeightage = this.showTotalKpisWeightage - weightage;
        }
        if(this.selectedRootKpis.length == this.allRootKpis.length){
          this.selecteAllRelatedKpis = true;
        }else{
          this.selecteAllRelatedKpis = false;
        }
      } else {
        this.showTotalKpisWeightage = 0;
        
        if(this.checkedActiveKpis.length == this.defaultCheckedActiveKpis.length && this.kpisListFromOrgPresentControl.length!=0){
          this.selecteAllActiveKpis = true;
        }else{
          this.selecteAllActiveKpis = false;
        }
        if(this.kpisListFromOrgPresentControl != undefined || this.kpisListFromOrgPresentControl != null || this.kpisListFromOrgPresentControl.length !== 0){
          this.kpisListFromOrgPresentControl.map((obj: any) => {
            if(obj.isActive==true){
              this.showTotalKpisWeightage = this.showTotalKpisWeightage + obj.weightage;
            }
            
          });
        }else {
          // console.log("this.kpisListFromOrgPresentControl",this.kpisListFromOrgPresentControl);
        }
      }
    },
    async updateKpiForControl(kpiObj: any) {
      let routeControlId = this.currentControlId;
      let totalWeightage = 0;
      let kpiId = kpiObj._id;
      if (totalWeightage <= 100) {
        delete kpiObj._id;
        try{
          await this.$http
            .post(
              `${process.env.VUE_APP_CONTROLS_API}/api/org/control/${routeControlId}/kpi/${kpiId}/update`,
              kpiObj
            )
            .then(async () => {
              toast.info("Updated", {
                timeout: 5000,
                closeOnClick: true,
                closeButton: "button",
                icon: true,
              });
              this.selectedRootKpis = [];
              await this.getAllOrgControls();
              await this.toggleTabs(0);
              this.showPopup = false;
            });
        }catch(e){
          toast.error(`cannot Save`, {
            timeout: 1000,
            closeOnClick: true,
            closeButton: 'button',
            icon: true
          });
        }finally{
          this.clickOnButton = false;
        }
      } else {
        toast.error("Total Weightage should be less than 100", {
          timeout: 5000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
        this.clickOnButton = false;
      }
    },
  },
  beforeUnmount() {
    sessionStorage.removeItem('selectedTab');
  }
});
</script>